export interface MessageMap {
  zh: string;
  en: string;
  cht: string;
}

export const messageMap = {
  '1000': {
    zh: '分享了一篇日志【{name}】',
    cht: '分享了一篇日誌【{name}】',
    en: 'A log was shared【{name}】',
  },
  '3020': {
    zh: '创建任务、添加执行人、添加抄送人',
    cht: '創建任務，添加執行人，添加抄送人',
    en: 'Create task, add executor, add CC',
  },
  '3021': {
    zh: '分配了一个任务给您',
    cht: '分配了一個任務給您',
    en: 'Assigned a task to you',
  },
  '3022': {
    zh: '抄送了一个任务给您',
    cht: '抄送了一個任務給您',
    en: 'CCed a task to you',
  },
  '3023': {
    zh: '修改了任务信息',
    cht: '修改了任務信息',
    en: 'Modified task information',
  },
  '3024': {
    zh: '新增了参考内容',
    cht: '新增了參考內容',
    en: 'Added reference content',
  },
  '3025': {
    zh: '变更了关联内容',
    cht: '變更了關聯內容',
    en: 'Changed associated content',
  },
  '3026': {
    zh: '取消了您执行任务',
    cht: '取消了您執行任務',
    en: 'Canceled your execution of the task',
  },
  '3027': {
    zh: '取消了抄送您任务',
    cht: '取消了抄送您任務',
    en: 'Canceled CC to you for the task',
  },
  '3028': {
    zh: '（自动提醒）任务逾期',
    cht: '（自動提醒）任務逾期',
    en: '(Auto reminder) Task overdue',
  },
  '3029': {
    zh: '在任务中@了您',
    cht: '在任務中@了您',
    en: '@mentioned you in the task',
  },
  '3031': {
    zh: '完成了任务',
    cht: '完成了任務',
    en: 'Completed the task',
  },
  '3032': {
    zh: '关闭了任务',
    cht: '關閉了任務',
    en: 'Completed the task',
  },
  '3033': {
    zh: '删除了任务',
    cht: '刪除了任務',
    en: 'Deleted the task',
  },
  '3034': {
    zh: '取消完成了任务',
    cht: '取消完成了任務',
    en: 'Canceled completion of the task',
  },
  '3035': {
    zh: '重新打开了任务',
    cht: '重新打開了任務',
    en: 'Reopened the task',
  },
  '4001': {
    zh: '创建人',
    cht: '創建人',
    en: 'Creator',
  },
  '4002': {
    zh: '项目管理员',
    cht: '項目管理員',
    en: 'project manager',
  },
  '4003': {
    zh: '项目组成员',
    cht: '項目組成員',
    en: 'project team member',
  },
  '4004': {
    zh: '项目负责人',
    cht: '項目負責人',
    en: 'Project leader',
  },
  '5001': {
    zh: '走访文件',
    cht: '走訪文件',
    en: 'Visiting document',
  },
  '5002': {
    zh: '荣大扫描王',
    cht: '榮大掃描王',
    en: 'Rongda Scan King',
  },
  '6001': {
    zh: '【{userName}】已读了您的【加急消息】,消息内容:【{text}】',
    cht: '【{userName}】已讀了您的【加急消息】,消息內容:【{text}】',
    en:
      '【{userName}】 has read your 【Urgent Message】, message content: 【{text}】',
  },
  '6005': {
    zh: '【{userName}】撤回了一条消息',
    cht: '【{userName}】撤回了一條消息',
    en: '【{userName}】 withdraw a Message',
  },
  '6006': {
    zh:
      '【{fromNameByCrmId}】希望使用文件的定位功能，需要您到【{projectName}】的“项目成员”中添加其成为项目成员',
    cht:
      '【{fromNameByCrmId}】希望使用文件的定位功能，需要您到【{projectName}】的“項目成員”中添加其成爲項目成員',
    en:
      '【{fromNameByCrmId}】 To use the file location feature, you need to add it as a project member in 【{projectName}】 project member',
  },
  '6007': {
    zh: '一个文件',
    cht: '一個文件',
    en: 'a file',
  },
  '6008': {
    zh: '一条群公告',
    cht: '一條羣公告',
    en: 'a Group Notice',
  },
  '6009': {
    zh: '一条消息',
    cht: '一條消息',
    en: 'a message',
  },
  '6010': {
    zh: '【{editCrmName}】完成了任务【{taskName}】',
    cht: '【{editCrmName}】完成了任務【{taskName}】',
    en: '【{editCrmName}】 has completed the task 【{taskName}】',
  },
  '6011': {
    zh: '【{editCrmName}】取消完成了任务【{taskName}】',
    cht: '【{editCrmName}】取消完成了任務【{taskName}】',
    en: '【{editCrmName}】 cancels the task 【{taskName}】',
  },
  '6100': {
    zh: '【{ownerCrmName}】发起了群聊',
    cht: '【{ownerCrmName}】發起了羣聊',
    en: '【{ownerCrmName}】 started a group chat',
  },
  '6101': {
    zh: '【{userName}】创建了【{orgName}】组织的【{groupName}】的群聊',
    cht: '【{userName}】創建了【{orgName}】組織的【{groupName}】的羣聊',
    en:
      '【{userName}】Created a group chat for 【{groupName}】 in 【{orgName}】 organization',
  },
  '6102': {
    zh: '【{userName}】邀请【{context}】进入群聊',
    cht: '【{userName}】邀請【{context}】進入羣聊',
    en: '【{userName}】 Invites 【{context}】 to join the group chat',
  },
  '6103': {
    zh: '【{userName}】邀请【{context}】等【{size}】人进入群聊',
    cht: '【{userName}】邀請【{context}】等【{size}】人進入羣聊',
    en:
      '【{userName}】 invites 【{context}】 and other 【{size}】 people to join the group chat',
  },
  '6104': {
    zh: '【{inviteUserName}】邀请【{beInviteUserName}】（业务老师）进入群聊',
    cht: '【{inviteUserName}】邀請【{beInviteUserName}】（業務老師）進入羣聊',
    en:
      '【{inviteUserName}】 Invite 【{beInviteUserName}】 (business teacher) to join the group chat',
  },
  '6105': {
    zh: '【{createLinkUserName}】邀请【{userInfoName}】进入群聊',
    cht: '【{createLinkUserName}】邀請【{userInfoName}】進入羣聊',
    en:
      '【{createLinkUserName}】 Invite 【{userInfoName}】 to join the group chat',
  },
  '6106': {
    zh: '【{crmName}】修改群名称为：【{groupName}】',
    cht: '【{crmName}】修改羣名稱爲：【{groupName}】',
    en: '【{crmName}】 Change the group name to: 【{groupName}】',
  },
  '6107': {
    zh: '【{crmName}】修改了群头像',
    cht: '【{crmName}】修改了羣頭像',
    en: '【{crmName}】 changed the group profile picture',
  },
  '6108': {
    zh: '您已经被移出了【{groupName}】群聊',
    cht: '您已經被移出了【{groupName}】羣聊',
    en: 'You have been removed from the 【{groupName}】 group chat',
  },
  '6109': {
    zh: '【{groupOwnerName}】将【{removeName}】移出了群聊',
    cht: '【{groupOwnerName}】將【{removeName}】移出了羣聊',
    en: '【{groupOwnerName}】 removed 【{removeName}】 from the group chat',
  },
  '6110': {
    zh: '【{groupOwnerName}】将【{removeName}】等【{size}】人移出了群聊',
    cht: '【{groupOwnerName}】將【{removeName}】等【{size}】人移出了羣聊',
    en:
      '【{groupOwnerName}】 removed 【{removeName}】 and other 【{size}】 people from the group chat',
  },
  '6111': {
    zh: '【{ownerCrmName}】已退出本群,【{nextCrmName}】已成为新群主',
    cht: '【{ownerCrmName}】已退出本羣,【{nextCrmName}】已成爲新羣主',
    en:
      '【{ownerCrmName}】 has exited this group, 【{nextCrmName}】 has become the new group owner',
  },
  '6112': {
    zh: '您已退出【{groupName}】群聊，将不再接收和查看本群消息及文件',
    cht: '您已退出【{groupName}】羣聊，將不再接收和查看本羣消息及文件',
    en:
      'You have quit the 【{groupName}】 group chat and will no longer receive and view the group messages and files',
  },
  '6113': {
    zh: '【{crmName}】已自动退出本群',
    cht: '【{crmName}】已自動退出本羣',
    en: '【{crmName}】 has automatically exited this group',
  },
  '6114': {
    zh: '【{ownerCrmName}】转让群主给【{tranCrmName}】',
    cht: '【{ownerCrmName}】轉讓羣主給【{tranCrmName}】',
    en: '【{ownerCrmName}】 Assign group master to 【{tranCrmName}】',
  },
  '6115': {
    zh:
      '【{groupName}】群聊已由【{ownerCrmName}】解散,原成员将不再接收和查看本群消息及文件',
    cht:
      '【{groupName}】羣聊已由【{ownerCrmName}】解散,原成員將不再接收和查看本羣消息及文件',
    en:
      '【{groupName}】 group chat has been dismissed by 【{ownerCrmName}】, original members will no longer receive and view the group messages and files',
  },
  '6116': {
    zh:
      '【{orgName}】组织下的【{projectName}】项目已删除，与项目关联的相关功能将无法使用',
    cht:
      '【{orgName}】組織下的【{projectName}】項目已刪除，與項目關聯的相關功能將無法使用',
    en:
      'The 【{projectName}】 project under the 【{orgName}】 organization has been deleted, and the related functions associated with the project are no longer available',
  },
  '6501': {
    en: '【{userName}】 copied me 【{voteName}】vote',
    cht: '【{userName}】抄送給我【{voteName}】投票',
    zh: '【{userName}】抄送给我【{voteName}】投票',
  },
  '6502': {
    en: '【{voteName}】 has completed',
    cht: '【{voteName}】已完成',
    zh: '【{voteName}】已完成',
  },
  '6503': {
    en:
      '【{userName}】 copied me 【{scheduleName}】 schedule,go to the main workbench - Calendar Table to view',
    cht:
      '【{userName}】抄送給我 【{scheduleName}】 日程,可前往主工作臺-日歷表查看',
    zh:
      '【{userName}】抄送给我 【{scheduleName}】 日程,可前往主工作台-日历表查看',
  },
  '6504': {
    en: '【{userName}】 are invited to join the project 【{projectName}】',
    cht: '【{userName}】邀請您加入項目【{projectName}】',
    zh: '【{userName}】邀请您加入项目【{projectName}】',
  },
  '6505': {
    en: '【{userName}】 applied to join 【{projectName}】 project',
    cht: '【{userName}】申請加入【{projectName}】項目',
    zh: '【{userName}】申请加入【{projectName}】项目',
  },
  '6506': {
    en: '【{userName}】 invite you to join 【{projectName}】 project',
    cht: '【{userName}】joinFlag您加入【{projectName}】項目',
    zh: '【{userName}】joinFlag您加入【{projectName}】项目',
  },
  '6507': {
    en: '【{userName}】 actively exit the project 【{projectName}】',
    cht: '【{userName}】已主動退出項目【{projectName}】',
    zh: '【{userName}】已主动退出项目【{projectName}】',
  },
  '6508': {
    en:
      'You have taken the initiative to withdraw from the project 【{projectName}】',
    cht: '您已主動退出項目【{projectName}】',
    zh: '您已主动退出项目【{projectName}】',
  },
  '6509': {
    en: '【{userName}】 has left the project【{projectName}】 project',
    cht: '【{userName}】已離開【{projectName}】項目',
    zh: '【{userName}】已离开【{projectName}】项目',
  },
  '6510': {
    en: 'You have been removed from the project 【{projectName}】',
    cht: '您已被移出【{projectName}】',
    zh: '您已被移出【{projectName}】',
  },
  '6511': {
    en: 'Your 【{projectName}】 role is set to 【{roleName}】',
    cht: '您所在【{projectName}】的角色被設置為【{roleName}】',
    zh: '您所在【{projectName}】的角色被设置为【{roleName}】',
  },
  '6512': {
    en:
      '【{userName}】has added approval comments in the 【{projectName}】 project 【{docName}】 etc, Please pay attention to the review“',
    cht:
      '【{userName}】在【{projectName}】項目【{docName}】等新增了審批意見，請註意查看',
    zh:
      '【{userName}】在【{projectName}】项目【{docName}】等新增了审批意见，请注意查看',
  },
  '6513': {
    en: '【{userName}】submitted an application for 【{processType}】 ',
    cht: '【{userName}】提交了【{processType}】申請',
    zh: '【{userName}】提交了【{processType}】申请',
  },
  '6514': {
    en: 'The approval you submitted has been 【{approvalResult}】',
    cht: '您提交的審批已審批【{approvalResult}】',
    zh: '您提交的审批已审批【{approvalResult}】',
  },
  '6515': {
    en:
      "【{userName}】 in 【{projectName}】  mentioned me in the project, The project's 【{processType}】【{approvalResult}】",
    cht:
      '【{userName}】在【{projectName}】項目提到我 該項目的【{processType}】【{approvalResult}】',
    zh:
      '【{userName}】在【{projectName}】项目提到我 该项目的【{processType}】【{approvalResult}】',
  },
  '6516': {
    en:
      '【{userName}】 initiated 【{processType}】【{approvalResult}】,Please know if you initiate',
    cht: '【{userName}】發起的【{processType}】【{approvalResult}】,請您知悉',
    zh: '【{userName}】发起的【{processType}】【{approvalResult}】,请您知悉',
  },
  '6517': {
    en:
      '【{userName}】 Transfer the 【{processType}】 of the 【{projectName}】 project to 【{handoverUserName}】',
    cht:
      '【{userName}】將【projectName】項目的【processType】轉交給【{handoverUserName}】',
    zh:
      '【{userName}】将【projectName】项目的【processType】转交给【{handoverUserName}】',
  },
  '6518': {
    en:
      'Dear user, your organization 【{orgName}】 still has 【{timeOut}】 days to expire, to avoid affecting your future use. Please renew it now!',
    cht:
      '親愛的用戶，您的組織【{orgName}】還有【{timeOut}】天到期，避免影響您的後期使用，快去續費吧！',
    zh:
      '亲爱的用户，您的组织【{orgName}】还有【{timeOut}】天到期，避免影响您的后期使用，快去续费吧！',
  },
  '6519': {
    en:
      "Dear user, your organization's 【{orgName}】 package has been successfully purchased. The purchase details are as follows: 【{num}】/【{space}】 GB, valid until 【{date}】.",
    cht:
      '親愛的用戶，您的組織【{orgName}】套餐購買成功，購買詳情如下：人數【{num}】人/空間【{space}】GB，有效期至【{date}】。',
    zh:
      '亲爱的用户，您的组织【{orgName}】套餐购买成功，购买详情如下：人数【{num}】人/空间【{space}】GB，有效期至【{date}】。',
  },
  '6520': {
    en:
      "Dear user, your organization's 【{orgName}】 package has been successfully expanded. The purchase details are as follows: 【{num}】/【{space}】 GB, valid until 【{date}】.",
    cht:
      '親愛的用戶，您的組織【{orgName}】套餐擴容成功，購買詳情如下：人數【{num}】人/空間【{space}】GB，有效期至【{date}】。',
    zh:
      '亲爱的用户，您的组织【{orgName}】套餐扩容成功，购买详情如下：人数【{num}】人/空间【{space}】GB，有效期至【{date}】。',
  },
  '6521': {
    en:
      "Dear user, your organization's 【{orgName}】 package has been successfully renewed. The purchase details are as follows: 【{num}】/【{space}】 GB, valid until 【{date}】.",
    cht:
      '親愛的用戶，您的組織【{orgName}】套餐續費成功，購買詳情如下：人數【{num}】人/空間【{space}】GB，有效期至【{date}】。',
    zh:
      '亲爱的用户，您的组织【{orgName}】套餐续费成功，购买详情如下：人数【{num}】人/空间【{space}】GB，有效期至【{date}】。',
  },
  '6522': {
    en:
      "【{userName}】 has exited the 【{projectName}】 project. You can invite service personnel to serve you again in the 'Online Services' module!",
    cht:
      '【{userName}】已退出【{projectName}】項目，您可以在」在線服務「模塊再次邀請服務人員為您服務！',
    zh:
      '【{userName}】已退出【{projectName}】项目，您可以在”在线服务“模块再次邀请服务人员为您服务！',
  },
  '6523': {
    zh:
      '【{userName}】在【{projectName}】的服务已完成，请在服务记录中进行评价！',
    en:
      'The service provided by 【{userName}】 on 【{projectName}】 has been completed. Please evaluate it in the service record!',
    cht:
      '【{userName}】在【{projectName}】的服務已完成，請在服務記錄中進行評價！',
  },
  '6524': {
    zh:
      '【{projectName}】项目的订单已被【{payUserName}】支付，订单金额：【{rmb}】元',
    en:
      'The order for the 【{projectName}】 project has been paid by 【{payUserName}】, with an order amount of 【{rmb}】 yuan',
    cht:
      '【{projectName}】項目的訂單已被【{payUserName}】支付，訂單金額：【{rmb}】元',
  },
  '6525': {
    zh: '您已成功支付【{projectName}】项目的订单，订单金额：【{rmb}】元',
    en:
      'You have successfully paid the order for the 【{projectName}】project, with an order amount of 【{rmb}】 yuan',
    cht: '您已成功支付【{projectName}】項目的訂單，訂單金額：【{rmb}】元',
  },
  '6526': {
    zh: '【{projectName}】项目有新的订单，订单金额：【{rmb}】元，请尽快支付！',
    en:
      'There is a new order for the 【{projectName}】project, with an order amount of 【{rmb}】 yuan. Please make the payment as soon as possible!',
    cht: '【{projectName}】項目有新的訂單，訂單金額：【{rmb}】元，請盡快支付！',
  },
  '6527': {
    zh: '【{userName}】用户已同意您的邀请',
    en: '【{userName}】 The user has agreed to your invitation',
    cht: '【{userName}】用戶已同意您的邀請',
  },
  '6528': {
    zh: '【{projectName}】已被【{userName}】终止',
    en: '【{projectName}】 has been terminated by 【{userName}】',
    cht: '【{projectName}】已被【{userName}】終止',
  },
  '6529': {
    zh: '【{projectName}】已移交至【{userName}】',
    en: '【{projectName}】 has been transferred to 【{userName}】',
    cht: '【{projectName}】已移交至【{userName}】',
  },
  '6530': {
    zh:
      '【{projectName}】 已被【{currentUserName}】移交至 【{newCreateUserName}】',
    en:
      '【{projectName}】 has been transferred from 【{currentUserName}】 to 【{newCreateUserName}】',
    cht:
      '【{projectName}】 已被【{currentUserName}】移交至 【{newCreateUserName}】',
  },
  '6531': {
    zh: '【{userName}】已将项目【{projectName}】删除',
    en: '【{userName}】 has deleted project 【{projectName}】',
    cht: '【{userName}】已將項目【{projectName}】刪除',
  },
  '6532': {
    zh: '【{userName}】拒绝加入项目！',
    en: '【{userName}】 refused to join the project!',
    cht: '【{userName}】拒絕加入項目！',
  },
  '6533': {
    zh: '【{userName}】已经加入项目！',
    en: '【{userName}】 has already joined the project!',
    cht: '【{userName}】已經加入項目！',
  },
  '6534': {
    zh: '【{projectName}】推进至 【{stageName}】阶段',
    en: '【{projectName}】 advancing to 【{stageName}】 stage',
    cht: '【{projectName}】推進至 【{stageName}】階段',
  },
  '6535': {
    zh: '【{userName}】抄送给您日志',
    en: '【{userName}】 cc to your log',
    cht: '【{userName}】抄送給您日誌',
  },
  '6536': {
    zh: '【{userName}】回复了您的评论',
    en: '【{userName}】 replied to your comment',
    cht: '【{userName}】回復了您的評論',
  },
  '6537': {
    zh: '【{taskName}】任务已逾期，请及时处理',
    en: '【{taskName}】 task has expired, please handle it promptly',
    cht: '【{taskName}】任務已逾期，請及時處理',
  },
  '6538': {
    zh: '【{userName}】已取消您执行【{taskName}】任务',
    cht: '【{userName}】已取消您執行【{taskName}】任務',
    en: '【{userName}】 has canceled your execution of the 【{taskName}】 task',
  },
  '6539': {
    zh: '【{userName}】已取消抄送您【{taskName}】任务',
    cht: '【{userName}】已取消抄送您【{taskName}】任務',
    en: '【{userName}】 has canceled the cc to your 【{taskName}】 task',
  },
  '6540': {
    zh: '【{userName}】抄送给您一个任务【{taskName}】',
    cht: '【{userName}】抄送給您一個任務【{taskName}】',
    en: '【{userName}】 cc you a task 【{taskName}】',
  },
  '6541': {
    zh: '【{userName}】分配给您一个任务【{taskName}】',
    cht: '【{userName}】分配給您一個任務【{taskName}】',
    en: '【{userName}】 assigned you a task 【{taskName}】',
  },
  '6542': {
    zh: '【{userName}】在【{taskName}】任务中@了您',
    cht: '【{userName}】在【{taskName}】任務中@了您',
    en: '【{userName}】 @ you in the 【{taskName}】 task',
  },
  '6543': {
    zh: '【{userName}】在【{projectName}】项目提到您context',
    cht: '【{userName}】在【{projectName}】項目提到您context',
    en:
      '【{userName}】 mentioned your context in the 【{projectName}】 project',
  },
  '6544': {
    zh: '【{userName}】抄送给我 【{meetingName}】 会议',
    cht: '【{userName}】抄送給我 【{meetingName}】 會議',
    en: '【{userName}】 cc me 【{meetingName}】 meeting',
  },
  '6545': {
    zh: '【{userNames}】提醒您 【{fileName}】 内的文件发生内容变更',
    cht: '【{userNames}】提醒您 【{fileName}】 內的文件發生內容變更',
    en:
      '【{userNames}】Reminder you that the content of the file in 【{fileName}】 has changed',
  },
  '6546': {
    zh: '【{userNames}】提醒您 【{fileName}】 发生了版本变更',
    cht: '【{userNames}】提醒您 【{fileName}】 發生了版本變更',
    en: '【{userNames}】Reminder of version changes to files in 【{fileName}】',
  },
  '6547': {
    zh: '【{userName}】申请加入组织【{orgName}】',
    cht: '【{userName}】申請加入組織【{orgName}】',
    en: '【{userName}】 applies to join the organization 【{orgName}】',
  },
  '6548': {
    zh: '您申请加入组织【{orgName}】的项目【{projectName}】',
    cht: '您申請加入組織【{orgName}】的項目【{projectName}】',
    en:
      'You have applied to join the project 【{projectName}】 of the organization 【{orgName}】',
  },
  '6549': {
    zh: '【{userName}】拒绝了您加入组织【{orgName}】',
    cht: '【{userName}】拒絕了您加入組織【{orgName}】',
    en: '【{userName}】 has refused you to join the organization 【{orgName}】',
  },
  '6550': {
    zh: '【{userName}】拒绝了您加入组织【{projectName}】',
    cht: '【{userName}】拒絕了您加入組織【{projectName}】',
    en:
      '【{userName}】 has refused you to join the organization 【projectName】',
  },
  '6551': {
    zh: '【{userName}】拒绝了您加入组织【{orgName}】的项目【projectName】',
    cht: '【{userName}】拒絕了您加入組織【{orgName}】的項目【projectName】',
    en:
      '【{userName}】 has rejected your participation in the project 【{projectName}】 of the organization 【{orgName}】',
  },
  '6552': {
    zh: '您申请加入组织【{orgName}】已通过',
    cht: '您申請加入組織【{orgName}】已通過',
    en:
      'Your application to join the organization 【{orgName}】 has been approved',
  },
  '6553': {
    zh: '您申请加入项目【{projectName}】已通过',
    cht: '您申請加入項目【{projectName}】已通過',
    en:
      'Your application to join the project 【{projectName}】 has been approved',
  },
  '6554': {
    zh: '【{userName}】拒绝加入组织',
    cht: '【{userName}】拒絕加入組織',
    en: '【{userName}】 refused to join the organization',
  },
  '6555': {
    zh: '【{userName}】已经加入组织',
    cht: '【{userName}】已經加入組織',
    en: '【{userName}】 has joined the organization',
  },
  '6556': {
    zh: '【{userName}】已退出组织【{orgName}】',
    cht: '【{userName}】已退出組織【{orgName}】',
    en: '【{userName}】 has exited the organization 【{orgName}】',
  },
  '6557': {
    zh: '【{userName}】邀请您加入【{orgName}】组织',
    cht: '【{userName}】邀請您加入【{orgName}】組織',
    en: '【{userName}】 invites you to join the 【{orgName}】 organization',
  },
  '6558': {
    zh: '【{userName}】邀请您加入【{orgName}】下的【{projectName}】项目',
    cht: '【{userName}】邀請您加入【{orgName}】下的【{projectName}】項目',
    en:
      '【{userName}】 invites you to join the 【{projectName}】 project under 【{orgName}】',
  },
  '6559': {
    zh:
      '【{userName}】邀请您加入【{projectName}】项目(项目编码:【{projectCode}】)',
    cht:
      '【{userName}】邀請您加入【{projectName}】項目(項目編碼:【{projectCode}】)',
    en:
      '【{userName}】 invites you to join the 【{projectName}】 project (project code: projectCode)',
  },
  '6560': {
    zh: '【{userName}】已将组织【{orgName}】删除',
    cht: '【{userName}】已將組織【{orgName}】刪除',
    en: '【{userName}】 has deleted organization 【{orgName}】',
  },
  '6561': {
    zh: '【{userName}】已退出组织,并将其所有项目交接给您',
    cht: '【{userName}】已退出組織,並將其所有項目交接給您',
    en:
      '【{userName}】 has exited the organization and handed over all its projects to you',
  },
  '6588': {
    zh: '【{userName}】已退出组织,并将【{projectName}】项目交接给您',
    cht: '【{userName}】已退出組織,並將【{projectName}】項目交接給您',
    en:
      '【{userName}】 has exited the organization and handed over its project 【{projectName}】 to you',
  },
  '6562': {
    zh: '【{userName}】在【{projectName}】提交了【{processType}】申请',
    cht: '【{userName}】在【{projectName}】提交了【{processType}】申請',
    en:
      '【{userName}】 submitted a 【{processType}】 application on 【{projectName}】',
  },
  '6563': {
    zh: '您提交的【{processType}】已审批【{approvalResult}】',
    cht: '您提交的【{processType}】已審批【{approvalResult}】',
    en:
      'The 【{processType}】 you submitted has been approved for 【{approvalResult}】',
  },
  '6564': {
    zh: '【{userName}】抄送我的【{processType}】【{approvalResult}】',
    cht: '【{userName}】抄送我的【{processType}】【{approvalResult}】',
    en: '【{userName}】 cc my 【{processType}】 【{approvalResult}】',
  },
  '6565': {
    zh:
      '您在【{projectName}】中提交的【{processType}】已审批【{approvalResult}】',
    cht:
      '您在【{projectName}】中提交的【{processType}】已審批【{approvalResult}】',
    en:
      'The processType you submitted in 【{projectName}】 has been approved for 【{approvalResult}】',
  },
  '6566': {
    zh: '【{userName}】对您的审批意见进行了回复，请查看!',
    cht: '【{userName}】對您的審批意見進行了回復，請查看!',
    en: '【{userName}】 has replied to your approval, please review!',
  },
  '6567': {
    zh: '【{userName}】将【{processType}】转交给【{handOverUserNames}】',
    cht: '【{userName}】將【{processType}】轉交給【{handOverUserNames}】',
    en:
      '【{userName}】 hands over 【{processType}】 to 【{handOverUserNames}】',
  },
  '6568': {
    zh:
      '【{userName}】将【{projectName}】项目的【{processType}】转交给【{handOverUserNames}】',
    cht:
      '【{userName}】將【{projectName}】項目的【{processType}】轉交給【{handOverUserNames}】',
    en:
      '【{userName}】 transfers the 【{processType}】 of the 【{projectName}】 project to 【{handOverUserNames}】',
  },
  '6569': {
    zh:
      '在使用智慧云全部功能前，请先创建一个组织，现在跟我一起来创建一个组织吧',
    cht:
      '在使用智慧雲全部功能前，請先創建一個組織，現在跟我一起來創建一個組織吧',
    en:
      'Before using all the functions of the smart cloud, please create an organization first. Now come with me to create an organization',
  },
  '6570': {
    zh: '用户【{userName}】已拒绝您的邀请',
    cht: '用戶【{userName}】已拒絕您的邀請',
    en: 'User 【{userName}】 has declined your invitation',
  },
  '6571': {
    zh: '您已被移出组织【{orgName}】!',
    cht: '您已被移出組織【{orgName}】!',
    en: 'You have been removed from the organization 【{orgName}】!',
  },
  '6572': {
    zh: '您的组织人数已超限,请及时扩容',
    cht: '您的組織人數已超限,請及時擴容',
    en:
      'The number of people in your organization has exceeded the limit, please expand it in a timely manner',
  },
  '6573': {
    zh: '您申请加入项目【{projectName}】',
    cht: '您申請加入項目【{projectName}】',
    en: 'You have applied to join the project 【{projectName}】',
  },
  '6574': {
    zh: '您申请加入组织【{orgName}】',
    cht: '您申請加入組織【{orgName}】',
    en: 'You have applied to join the organization 【{orgName}】',
  },
  '6575': {
    zh: '您已退出组织【{orgName}】',
    cht: '您已退出組織【{orgName}】',
    en: 'You have exited the organization 【{orgName}】',
  },
  '6576': {
    zh: '您已将组织【{orgName}】删除',
    cht: '您已將組織【{orgName}】刪除',
    en: 'You have deleted the organization 【{orgName}】',
  },
  '6577': {
    zh: '【{projectName}】已被您终止',
    cht: '【{projectName}】已被您終止',
    en: '【{projectName}】 has been terminated by you',
  },
  '6578': {
    zh: '【{projectName}】 已被【{currentUserName}】移交至您',
    cht: '【{projectName}】 已被【{currentUserName}】移交至您',
    en:
      '【{projectName}】 has been handed over to you by 【{currentUserName}】',
  },
  '6579': {
    zh: '您已将项目【{projectName}】删除',
    cht: '您已將項目【{projectName}】刪除',
    en: 'You have deleted project 【{projectName}】',
  },
  '6580': {
    zh: '分配一个任务给您',
    cht: '分配一個任務給您',
    en: 'Assign a task to you',
  },
  '6581': {
    zh: '抄送一个任务给您',
    cht: '抄送一個任務給您',
    en: 'cc a task to you',
  },
  '6600': {
    zh: '评论了您的日志',
    cht: '評論了您的日誌',
    en: 'Commented on your log',
  },
  '6601': {
    zh: '回复了您的日志评论',
    cht: '回復了您的日誌評論',
    en: 'Responded to your log comment',
  },
  '6602': {
    zh: '在日志中@了您',
    cht: '在日誌中@了您',
    en: '@you in the log',
  },
  '6702': {
    zh:
      '【{userName}】创建的【{projectName}】项目流量不足，请进入IT数据中台查看并充值。',
    cht:
      '【{userName}】創建的【{projectName}】項目流量不足，請進入IT數據中台查看並充值。',
    en:
      'The project created by 【{userName}】 has insufficient traffic for the 【{projectName}】 project. Please enter the IT data center to view and recharge.',
  },
  '6703': {
    zh:
      '【{userName}】创建的【{projectName}】流量已充值，请进入IT数据中台查看用量详情。',
    cht:
      '【{userName}】創建的【{projectName}】流量已充值，請進入IT數據中台查看用量詳情。',
    en:
      'The traffic created by 【{userName}】 for 【{projectName}】 has been recharged. Please enter the IT data center to view the usage details.',
  },
  '8001': {
    zh: '创建于',
    cht: '創建於',
    en: 'Created on',
  },
  '8002': {
    zh: '收到投放广告的用户总数：%s',
    cht: '收到投放廣告的用戶總數：%s',
    en: 'Total number of users receiving advertisements:%s',
  },
  '8003': {
    zh: '字段没有填写',
    cht: '字段沒有填寫',
    en: 'Field not filled in',
  },
  '8004': {
    zh: '字段超出最大填写位数',
    cht: '字段超出最大填寫位數',
    en: 'Field exceeds the maximum number of digits filled in',
  },
  '8005': {
    zh:
      '您正在本地编辑的文件【%s】已被取消编辑锁定，智慧云当前不会自动更新本次编辑内容，请您注意文件版本变更！',
    cht:
      '您正在本地編輯的文件【%s】已被取消編輯鎖定，智慧雲當前不會自動更新本次編輯內容，請您註意文件版本變更！',
    en:
      'The file [%s] you are currently editing locally has been unlocked for editing. Smart Cloud will not automatically update this editing content. Please pay attention to file version changes!',
  },
  '8006': {
    zh: '收藏数量已达上限（%s）！',
    cht: '收藏數量已達上限（%s）！',
    en: 'The number of favorites has reached the maximum limit (%s)!',
  },
  '8007': {
    zh: '不是excel文件',
    cht: '不是excel文件',
    en: 'Not an Excel file',
  },
  '8008': {
    zh: '个人日志',
    cht: '個人日誌',
    en: 'Personal log',
  },
  '8009': {
    zh: '本次还原成功%s个，失败%s个',
    cht: '本次還原成功%s個，失敗%s個',
    en: 'This restore succeeded%s, failed%s',
  },
  '8010': {
    zh: '您',
    cht: '您',
    en: 'you',
  },
  '9001': {
    zh: '项目文档',
    en: 'Project Document',
    cht: '項目文檔',
  },
  '9002': {
    zh: '底稿文档',
    en: 'manuscript document',
    cht: '底稿文檔',
  },
  '9003': {
    zh: '客户文档',
    en: 'Customer Document',
    cht: '客戶文檔',
  },
  '9004': {
    zh: '项目会议',
    en: 'Project Meeting',
    cht: '項目會議',
  },
  '9005': {
    zh: '项目投票',
    en: 'Project Voting',
    cht: '項目投票',
  },
  '9006': {
    zh: '项目日志',
    en: 'Project Log',
    cht: '項目日誌',
  },
  '9007': {
    zh: '项目任务',
    en: 'Project Task',
    cht: '項目任務',
  },
  '9008': {
    zh: '项目审批',
    en: 'Project Approval',
    cht: '項目審批',
  },
  '9009': {
    zh: '个人网盘文档',
    en: 'Personal Network Disk Document',
    cht: '個人網盤文檔',
  },
  '9010': {
    zh: '聊天文件',
    en: 'chat files',
    cht: '聊天文件',
  },
  '9011': {
    zh: '阶段文件夹',
    en: 'Stage Folder',
    cht: '階段文件夾',
  },
  '9012': {
    zh: '底稿上传',
    en: 'manuscript upload',
    cht: '底稿上傳',
  },
  '9013': {
    zh: '拜访记录附件',
    en: 'Visit Record Attachment',
    cht: '拜訪記錄附件',
  },
  '9014': {
    zh: '富文本编辑器上传',
    en: 'Rich Text Editor Upload',
    cht: '富文本編輯器上傳',
  },
  '9015': {
    zh: '走访文件',
    en: 'Visiting Documents',
    cht: '走訪文件',
  },
  '9016': {
    zh: '穿行测试',
    en: 'walkthrough test',
    cht: '穿行測試',
  },
  '9017': {
    cht: '榮大掃描王',
    zh: '荣大扫描王',
    en: 'Rongda Scanning King',
  },
  '9018': {
    cht: '雲協作遷移',
    zh: '云协作迁移',
    en: 'Cloud Collaboration Migration',
  },
  '9019': {
    cht: '智能網查',
    zh: '智能网查',
    en: 'Intelligent Network Search',
  },
  '9020': {
    cht: '企業客戶',
    zh: '企业客户',
    en: 'enterprise customer',
  },
  '9021': {
    cht: '自然人客戶',
    zh: '自然人客户',
    en: 'natural person customer',
  },
  '9022': {
    cht: '中介機構',
    zh: '中介机构',
    en: 'intermediary agency',
  },
  '9023': {
    cht: '進行中',
    zh: '进行中',
    en: 'in progress',
  },
  '9024': {
    cht: '已完成',
    zh: '已完成',
    en: 'completed',
  },
  '9025': {
    cht: '已終止',
    zh: '已终止',
    en: 'terminated',
  },
  '9026': {
    cht: '鎖定',
    zh: '锁定',
    en: 'locked',
  },
  '9027': {
    cht: '未鎖定',
    zh: '未锁定',
    en: 'unlocked',
  },
  '9028': {
    cht: '普通',
    zh: '普通',
    en: 'ordinary',
  },
  '9029': {
    cht: '項目',
    zh: '项目',
    en: 'project',
  },
  '9030': {
    cht: '會計師事務所',
    zh: '会计师事务所',
    en: 'accounting firm',
  },
  '9031': {
    cht: '律師事務所',
    zh: '律师事务所',
    en: 'law firm',
  },
  '9032': {
    cht: '資產評估機構',
    zh: '资产评估机构',
    en: 'Asset Evaluation Agency',
  },
  '9033': {
    cht: '信用評級機構',
    zh: '信用评级机构',
    en: 'Credit Rating Agency',
  },
  '9034': {
    cht: '券商機構',
    zh: '券商机构',
    en: 'securities firms',
  },
  '-1': {
    zh: '成功',
    cht: '成功',
    en: ' success ',
  },
  '-2': {
    zh: '失败',
    cht: '失敗',
    en: ' failure ',
  },
  '-3': {
    zh: '系统繁忙，请稍后再试',
    cht: '系統繁忙，請稍後再試',
    en: ' system busy, please try again later ',
  },
  '-4': {
    zh: 'token验证不通过',
    cht: 'token驗證不通過',
    en: 'token authentication fails ',
  },
  '-5': {
    zh: '参数验证不通过',
    cht: '參數驗證不通過',
    en: ' parameter verification failed ',
  },
  '-6': {
    zh: '查询结果为空',
    cht: '查詢結果爲空',
    en: ' query result is empty ',
  },
  '-7': {
    zh: '添加失败',
    cht: '添加失敗',
    en: ' Add failed ',
  },
  '-8': {
    zh: '修改失败',
    cht: '修改失敗',
    en: ' Modification failed ',
  },
  '-9': {
    zh: '删除失败',
    cht: '刪除失敗',
    en: ' Delete failed ',
  },
  '-10': {
    zh: '关闭失败',
    cht: '關閉失敗',
    en: ' shutdown failure ',
  },
  '-11': {
    zh: '引入失败',
    cht: '引入失敗',
    en: ' introduce failure ',
  },
  '-12': {
    zh: '引入失败',
    cht: '引入失敗',
    en: ' import failure ',
  },
  '-13': {
    zh: '复制失败',
    cht: '複製失敗',
    en: ' Copy failed ',
  },
  '-14': {
    zh: '剪切失败',
    cht: '剪切失敗',
    en: ' shear failure ',
  },
  '-15': {
    zh: 'userId不能为空！',
    cht: 'userId不能爲空！',
    en: 'userId cannot be empty!',
  },
  '-16': {
    zh: '已存在相同数据',
    cht: '已存在相同數據',
    en: ' same data already exists ',
  },
  '-17': {
    zh: '项目id不能为空！',
    cht: '項目id不能爲空！',
    en: ' Project id cannot be empty!',
  },
  '-18': {
    zh: '关闭失败',
    cht: '關閉失敗',
    en: ' shutdown failure ',
  },
  '-19': {
    zh: '网络异常',
    cht: '網絡異常',
    en: ' Network exception ',
  },
  '-20': {
    zh: '导出失败',
    cht: '導出失敗',
    en: ' Export failure ',
  },
  '-21': {
    zh: '空文件夹不允许下载',
    cht: '空文件夾不允許下載',
    en: ' empty folder not allowed to download ',
  },
  '-22': {
    zh: 'docIds为空',
    cht: 'docIds爲空',
    en: 'docIds are empty ',
  },
  '-23': {
    zh: '导出任务附件过大是否继续导出附件',
    cht: '導出任務附件過大是否繼續導出附件',
    en:
      ' Export task attachment is too large to continue exporting attachments ',
  },
  '-24': {
    zh: '当前版本较低，请升级为最新版本',
    cht: '當前版本較低，請升級爲最新版本',
    en: ' the current version is lower, please upgrade to the latest version ',
  },
  '-25': {
    zh: '操作失败',
    cht: '操作失敗',
    en: ' Operation failed ',
  },
  '-26': {
    zh: '无效广告',
    cht: '無效廣告',
    en: ' invalid advertisement ',
  },
  '-27': {
    zh: '当前项目已终止，不可进行此操作',
    cht: '當前項目已終止，不可進行此操作',
    en:
      ' The current project has been terminated, cannot perform this operation ',
  },
  '-28': {
    zh: '当前项目已删除，不可进行此操作',
    cht: '當前項目已刪除，不可進行此操作',
    en: ' Current item deleted, cannot do this operation ',
  },
  '-29': {},
  '-30': {
    zh: '版本过低,无法自动升级,请在荣大官网下载',
    cht: '版本過低,無法自動升級,請在榮大官網下載',
    en:
      ' the version is too low to automatically upgrade, please download it from Rong University official website ',
  },
  '-31': {
    zh: 'RSA校验异常',
    cht: 'RSA校驗異常',
    en: 'RSA check exception ',
  },
  '-32': {
    zh: 'crmId不能为空',
    cht: 'crmId不能爲空',
    en: 'crmId cannot be empty ',
  },
  '-33': {
    zh: '用户集合不能为空',
    cht: '用戶集合不能爲空',
    en: ' user set cannot be empty ',
  },
  '-34': {
    zh: '导出失败，当前访问用户过多，建议避开工作高峰期导出，请稍后再试',
    cht: '導出失敗，當前訪問用戶過多，建議避開工作高峯期導出，請稍後再試',
    en:
      ' Export failed, too many users are currently accessing, it is recommended to avoid exporting during peak hours, please try again later ',
  },
  '-35': {
    zh: '灰度验证不通过',
    cht: '灰度驗證不通過',
    en: ' gray verification fails ',
  },
  '-36': {
    zh: '境外IP暂不支持登录，如有问题请联系售后15600256315',
    cht: '境外IP暫不支持登錄，如有問題請聯繫售後15600256315',
    en:
      ' foreign IP address login is not supported for now, if you have any questions please contact the after-sales service 15600256315',
  },
  '-37': {
    zh: '目录名称已存在',
    cht: '目錄名稱已存在',
    en: ' directory name already exists ',
  },
  '-38': {
    zh: '文件名称已存在',
    cht: '文件名稱已存在',
    en: ' file name already exists ',
  },
  '-39': {
    zh: '上传文件格式不符',
    cht: '上傳文件格式不符',
    en: ' upload file format does not match ',
  },
  '-40': {
    zh: '文件信息不存在',
    cht: '文件信息不存在',
    en: ' file information does not exist ',
  },
  '-41': {
    zh: '文件版本信息不存在',
    cht: '文件版本信息不存在',
    en: ' file version information does not exist ',
  },
  '-42': {
    zh: '该版本是文件最新版本',
    cht: '該版本是文件最新版本',
    en: ' this version is the latest version of the file ',
  },
  '-43': {
    zh: '文件来源是底稿时，必须传入parentId',
    cht: '文件來源是底稿時，必須傳入parentId',
    en: " 'parentId' must be passed when the file source is a manuscript",
  },
  '-44': {
    zh: '找不到项目阶段',
    cht: '找不到項目階段',
    en: ' project phase not found ',
  },
  '-45': {
    zh: '文档来源为null',
    cht: '文檔來源爲null',
    en: ' document source is null',
  },
  '-46': {
    zh: '项目来源不是客户文档时候，项目ID不能为空',
    cht: '項目來源不是客戶文檔時候，項目ID不能爲空',
    en:
      ' the project ID cannot be empty when the project source is not customer documentation ',
  },
  '-47': {
    zh: '项目文档重命名异常',
    cht: '項目文檔重命名異常',
    en: ' project document rename exception ',
  },
  '-48': {
    zh: '该文档已存在关联',
    cht: '該文檔已存在關聯',
    en: ' this document already has an association ',
  },
  '-49': {
    zh: '底稿文档移动异常',
    cht: '底稿文檔移動異常',
    en: ' manuscript document movement exception ',
  },
  '-50': {
    zh: '该文档不支持解析',
    cht: '該文檔不支持解析',
    en: ' this document does not support parsing ',
  },
  '-51': {
    zh: '包含锁定文件，无法删除',
    cht: '包含鎖定文件，無法刪除',
    en: ' contains locked file and cannot be deleted ',
  },
  '-52': {
    zh: '标签不能为空',
    cht: '標籤不能爲空',
    en: ' label cannot be empty ',
  },
  '-53': {
    zh: '标签最多添加10个',
    cht: '標籤最多添加10個',
    en: ' Add up to 10 labels ',
  },
  '-54': {
    zh: '已存在相同标签',
    cht: '已存在相同標籤',
    en: ' same label already exists ',
  },
  '-55': {
    zh: '标签名不能相同',
    cht: '標籤名不能相同',
    en: ' label name cannot be the same ',
  },
  '-56': {
    zh: '操作失败',
    cht: '操作失敗',
    en: ' Operation failed ',
  },
  '-57': {
    zh: '审批中/审批通过的文件不可手动解锁！',
    cht: '審批中/審批通過的文件不可手動解鎖！',
    en: ' Files under approval/approved cannot be manually unlocked!',
  },
  '-58': {
    zh: '包含锁定文件夹，无法删除',
    cht: '包含鎖定文件夾，無法刪除',
    en: ' contains locked folder, cannot delete ',
  },
  '-59': {
    zh: '文件格式不支持预览',
    cht: '文件格式不支持預覽',
    en: ' File format does not support preview ',
  },
  '-60': {
    zh: '不能跨项目剪切',
    cht: '不能跨項目剪切',
    en: " Can't cut across items ",
  },
  '-61': {
    zh: '没有可复制的数据',
    cht: '沒有可複製的數據',
    en: ' No data to copy ',
  },
  '-62': {
    zh: '文件已上锁,请刷新页面,联系文件锁定人',
    cht: '文件已上鎖,請刷新頁面,聯繫文件鎖定人',
    en:
      ' the file is locked, please refresh the page, contact the file lock person ',
  },
  '-63': {
    zh: '未在智慧云查出此组织信息,请重新输入',
    cht: '未在智慧雲查出此組織信息,請重新輸入',
    en:
      ' did not find this organization information in the Wisdom Cloud, please re-enter ',
  },
  '-64': {
    zh: '未在智慧云查出此项目编码,请重新输入',
    cht: '未在智慧雲查出此項目編碼,請重新輸入',
    en: ' did not find this item code in the Wisdom Cloud, please re-enter ',
  },
  '-65': {
    zh: '您对应的智慧云项目包含非云协作文件，请删除后在尝试迁移！',
    cht: '您對應的智慧雲項目包含非雲協作文件，請刪除後在嘗試遷移！',
    en:
      ' Your corresponding Smart Cloud project contains non-cloud collaboration files, please delete them before attempting migration!',
  },
  '-66': {
    zh: '上传文件目录不正确',
    cht: '上傳文件目錄不正確',
    en: ' upload file directory incorrect ',
  },
  '-67': {
    zh: '无法删除粘贴中文件，请等待粘贴完成！',
    cht: '無法刪除粘貼中文件，請等待粘貼完成！',
    en:
      ' cannot delete the pasted file, please wait until the pasting is complete!',
  },
  '-68': {
    zh: '解析PC端下载参数异常',
    cht: '解析PC端下載參數異常',
    en: ' PC download parameter parsing exception ',
  },
  '-69': {
    zh: '文件上传成功。系统解锁失败，请手动解锁',
    cht: '文件上傳成功。系統解鎖失敗，請手動解鎖',
    en:
      ' file uploaded successfully. System unlock failed, please manually unlock ',
  },
  '-70': {
    zh: '文档ID格式不正确',
    cht: '文檔ID格式不正確',
    en: ' document ID is not formatted correctly ',
  },
  '-71': {
    zh: '不支持上传新版本',
    cht: '不支持上傳新版本',
    en: ' Uploading new versions is not supported ',
  },
  '-72': {
    zh: 'XB文件不支持在线编辑',
    cht: 'XB文件不支持在線編輯',
    en: 'XB file does not support online editing ',
  },
  '-73': {
    zh: '本地编辑模式切换失败',
    cht: '本地編輯模式切換失敗',
    en: ' Local edit mode switchover failed ',
  },
  '-74': {
    zh: '该文件夹不存在',
    cht: '該文件夾不存在',
    en: ' this folder does not exist ',
  },
  '-75': {
    zh: '导出失败，最高导出10000个文件与文件夹，请缩小导出范围',
    cht: '導出失敗，最高導出10000個文件與文件夾，請縮小導出範圍',
    en:
      ' Export failure, maximum export 10000 files and folders, please reduce the export range ',
  },
  '-76': {
    zh: '路径异常，已将文件保存至荣大扫描王中',
    cht: '路徑異常，已將文件保存至榮大掃描王中',
    en: ' abnormal path, saved file to Rongda Scan King ',
  },
  '-77': {
    zh: '上传文件发生异常',
    cht: '上傳文件發生異常',
    en: ' upload file exception ',
  },
  '-78': {
    zh: '保存失败，路径长度超出2500字',
    cht: '保存失敗，路徑長度超出2500字',
    en: ' Save failed, path length exceeded 2500 words ',
  },
  '-79': {
    zh: '文件数据异常',
    cht: '文件數據異常',
    en: ' file data exception ',
  },
  '-80': {
    zh: '文件路径不存在',
    cht: '文件路徑不存在',
    en: ' file path does not exist ',
  },
  '-81': {
    zh: 'web唤醒PC端下载，数据不存在',
    cht: 'web喚醒PC端下載，數據不存在',
    en: 'web wakes up PC download, data does not exist ',
  },
  '-84': {
    zh: '文件后缀名错误',
    cht: '文件後綴名錯誤',
    en: ' file suffix error ',
  },
  '-85': {
    zh: '文档编辑模式设置有更新,请刷新列表后重试',
    cht: '文檔編輯模式設置有更新,請刷新列表後重試',
    en:
      ' document editing mode Settings have been updated, please refresh the list and try again ',
  },
  '-86': {
    zh: '操作失败，目录中已存在根目录',
    cht: '操作失敗，目錄中已存在根目錄',
    en: ' Operation failed, root already exists in directory ',
  },
  '-87': {
    zh: '密码有误,与原始密码不匹配',
    cht: '密碼有誤,與原始密碼不匹配',
    en: ' password error, does not match the original password ',
  },
  '-88': {
    zh: '账号或密码不正确，请重新输入',
    cht: '賬號或密碼不正確，請重新輸入',
    en: ' Account or password is incorrect, please re-enter ',
  },
  '-89': {
    zh: '没有该权限',
    cht: '沒有該權限',
    en: ' do not have this permission ',
  },
  '-90': {
    zh: '暂无对应权限，请联系管理员！',
    cht: '暫無對應權限，請聯繫管理員！',
    en: ' No corresponding permission, please contact the administrator!',
  },
  '-91': {
    zh: '暂无对应权限，请联系管理员！',
    cht: '暫無對應權限，請聯繫管理員！',
    en: ' No corresponding permission, please contact the administrator!',
  },
  '-92': {
    zh: '凭证识别模板保存失败',
    cht: '憑證識別模板保存失敗',
    en: ' Certificate identification template saving failure ',
  },
  '-93': {
    zh: '任务已被认领',
    cht: '任務已被認領',
    en: ' Mission has been claimed ',
  },
  '-94': {
    zh: '该审批类型已被引用，无法删除',
    cht: '該審批類型已被引用，無法刪除',
    en: ' this approval type has been referenced and cannot be deleted ',
  },
  '-95': {
    zh: '该成员不在项目中',
    cht: '該成員不在項目中',
    en: ' This member is not in the project ',
  },
  '-96': {
    zh: '成员已在项目中',
    cht: '成員已在項目中',
    en: ' member already in the project ',
  },
  '-97': {
    zh: '退出失败',
    cht: '退出失敗',
    en: ' Exit failure ',
  },
  '-98': {
    zh: '该成员已在申请中',
    cht: '該成員已在申請中',
    en: ' the member is being applied for ',
  },
  '-99': {
    zh: '该角色下仍有人员，不可删除！',
    cht: '該角色下仍有人員，不可刪除！',
    en: ' This role still has personnel, cannot be deleted!',
  },
  '-100': {
    zh: '角色名称已存在',
    cht: '角色名稱已存在',
    en: ' Role name already exists ',
  },
  '-101': {
    zh: '该任务不存在！',
    cht: '該任務不存在！',
    en: ' The task does not exist!',
  },
  '-102': {
    zh: '不是该任务执行人',
    cht: '不是該任務執行人',
    en: ' not the person performing the task ',
  },
  '-103': {
    zh: '有未完成的子任务！',
    cht: '有未完成的子任務！',
    en: ' There are unfinished subtasks!',
  },
  '-104': {
    zh: '关联的审批流程未通过,无法完成该任务',
    cht: '關聯的審批流程未通過,無法完成該任務',
    en:
      ' the associated approval process has not passed and the task cannot be completed ',
  },
  '-105': {
    zh: '主版本不可删除',
    cht: '主版本不可刪除',
    en: ' major version cannot be deleted ',
  },
  '-106': {
    zh: '启用失败',
    cht: '啓用失敗',
    en: ' Enable failed ',
  },
  '-107': {
    zh: '禁用失败',
    cht: '禁用失敗',
    en: ' Disable failure ',
  },
  '-108': {
    zh: '任务之前已完成',
    cht: '任務之前已完成',
    en: ' the task has been completed before ',
  },
  '-109': {
    zh: '已完成任务',
    cht: '已完成任務',
    en: ' mission completed ',
  },
  '-110': {
    zh: '该流程有在进行的流程,不可删除',
    cht: '該流程有在進行的流程,不可刪除',
    en: ' this process has an ongoing process, cannot be deleted ',
  },
  '-111': {
    zh: '任务导入失败',
    cht: '任務導入失敗',
    en: ' Task import failed ',
  },
  '-112': {
    zh: '模型数据为空，请先设计流程并成功保存，再进行发布',
    cht: '模型數據爲空，請先設計流程併成功保存，再進行發佈',
    en:
      ' Model data is empty, please design the process and save successfully before publishing ',
  },
  '-113': {
    zh: '数据模型不符要求，请至少设计一条主线流程',
    cht: '數據模型不符要求，請至少設計一條主線流程',
    en:
      ' Data model does not meet requirements, please design at least one main line flow ',
  },
  '-114': {
    zh: '请先将流程禁用后删除',
    cht: '請先將流程禁用後刪除',
    en: ' Please disable the process before deleting it ',
  },
  '-115': {
    zh: '项目不存在',
    cht: '項目不存在',
    en: ' item does not exist ',
  },
  '-116': {
    zh: '任务已关闭！',
    cht: '任務已關閉！',
    en: ' Mission closed!',
  },
  '-117': {
    zh: '暂无对应权限，请联系管理员！',
    cht: '暫無對應權限，請聯繫管理員！',
    en: ' No corresponding permission, please contact the administrator!',
  },
  '-118': {
    zh: '无操作权限，请联系对应项目组负责人处理',
    cht: '無操作權限，請聯繫對應項目組負責人處理',
    en:
      ' no operation permission, please contact the person in charge of the corresponding project team ',
  },
  '-119': {
    zh: '没有文件的预览权限',
    cht: '沒有文件的預覽權限',
    en: ' no file preview permission ',
  },
  '-120': {
    zh: '没有文件的下载权限',
    cht: '沒有文件的下載權限',
    en: ' no file download permission ',
  },
  '-121': {
    zh: '当前用户不是项目的创建者，无权操作！',
    cht: '當前用戶不是項目的創建者，無權操作！',
    en:
      ' The current user is not the project creator and has no right to operate!',
  },
  '-122': {
    zh: '缺少流程图',
    cht: '缺少流程圖',
    en: ' lack of flow chart ',
  },
  '-123': {
    zh: '项目已经处于删除状态！',
    cht: '項目已經處於刪除狀態！',
    en: ' The project has been deleted!',
  },
  '-124': {
    zh: '项目已经处于终止状态！',
    cht: '項目已經處於終止狀態！',
    en: ' Project has been terminated!',
  },
  '-125': {
    zh: '项目终止信息不能为空',
    cht: '項目終止信息不能爲空',
    en: ' Project termination information cannot be empty ',
  },
  '-126': {
    zh: '项目终止失败',
    cht: '項目終止失敗',
    en: ' Project termination failure ',
  },
  '-127': {
    zh: '项目没有处于的阶段',
    cht: '項目沒有處於的階段',
    en: ' the phase the project is not in ',
  },
  '-128': {
    zh: '项目推进失败',
    cht: '項目推進失敗',
    en: ' project promotion failure ',
  },
  '-129': {
    zh: '项目阶段不存在',
    cht: '項目階段不存在',
    en: ' project phase does not exist ',
  },
  '-130': {
    zh: '项目已经处于完成状态了',
    cht: '項目已經處於完成狀態了',
    en: ' the project has been completed ',
  },
  '-131': {
    zh: '投票失败',
    cht: '投票失敗',
    en: ' failed to vote ',
  },
  '-132': {
    zh: '非本人上传文件不可删除',
    cht: '非本人上傳文件不可刪除',
    en: ' files uploaded by others cannot be deleted ',
  },
  '-133': {
    zh: '填写的规则与所选投票规则类型不符合',
    cht: '填寫的規則與所選投票規則類型不符合',
    en: ' The rule filled in does not match the type of voting rule selected ',
  },
  '-134': {
    zh: '不可重复投票',
    cht: '不可重複投票',
    en: ' no double voting ',
  },
  '-135': {
    zh: '投票未到开始时间',
    cht: '投票未到開始時間',
    en: ' voting has not reached the start time ',
  },
  '-136': {
    zh: '不能找到项目的第一个阶段',
    cht: '不能找到項目的第一個階段',
    en: ' cannot find the first phase of the project ',
  },
  '-137': {
    zh: '投票未结束',
    cht: '投票未結束',
    en: ' voting not closed ',
  },
  '-138': {
    zh: '人数限制小于人员限制人数总和',
    cht: '人數限制小於人員限制人數總和',
    en: ' the number limit is less than the total number of personnel limit ',
  },
  '-139': {
    zh: '名称重复',
    cht: '名稱重複',
    en: ' duplicate name ',
  },
  '-140': {
    zh: '该业务类型名称已经存在了',
    cht: '該業務類型名稱已經存在了',
    en: ' the business type name already exists ',
  },
  '-141': {
    zh: '业务类型不存在',
    cht: '業務類型不存在',
    en: ' business type does not exist ',
  },
  '-142': {
    zh: '执行阶段更新失败',
    cht: '執行階段更新失敗',
    en: ' run-time update failed ',
  },
  '-143': {
    zh: '项目初始化阶段失败',
    cht: '項目初始化階段失敗',
    en: ' project initialization phase failed ',
  },
  '-144': {
    zh: '在全部阶段内没有找到要限定的对应开始阶段或者结束阶段',
    cht: '在全部階段內沒有找到要限定的對應開始階段或者結束階段',
    en:
      ' no corresponding beginning or end stage to be qualified is found in all stages ',
  },
  '-145': {
    zh: '项目阶段导入失败',
    cht: '項目階段導入失敗',
    en: ' Project phase import failed ',
  },
  '-146': {
    zh: '开始阶段不能大于结束阶段',
    cht: '開始階段不能大於結束階段',
    en: ' the beginning stage must not be greater than the end stage ',
  },
  '-147': {
    zh: '项目没有选择过模板',
    cht: '項目沒有選擇過模板',
    en: ' no template has been selected for the project ',
  },
  '-148': {
    zh: '项目绑定选择的任务模板失败',
    cht: '項目綁定選擇的任務模板失敗',
    en: ' Project binding selected task template failed ',
  },
  '-149': {
    zh: '任务模板不存在',
    cht: '任務模板不存在',
    en: ' task template does not exist ',
  },
  '-150': {
    zh: '项目编码已存在',
    cht: '項目編碼已存在',
    en: ' item code already exists ',
  },
  '-151': {
    zh: '项目存在被其他项目关联，删除失败',
    cht: '項目存在被其他項目關聯，刪除失敗',
    en: ' the item has been associated with another item, failed to delete ',
  },
  '-152': {
    zh: '日程已删除',
    cht: '日程已刪除',
    en: ' Schedule deleted ',
  },
  '-153': {
    zh: '会议已删除',
    cht: '會議已刪除',
    en: ' Meeting deleted ',
  },
  '-154': {
    zh: '投票已删除',
    cht: '投票已刪除',
    en: ' Vote deleted ',
  },
  '-155': {
    zh: '填报工时设置已变更',
    cht: '填報工時設置已變更',
    en: ' Reporting time Settings changed ',
  },
  '-156': {
    zh: '工时调整不可超过当前实际工时',
    cht: '工時調整不可超過當前實際工時',
    en:
      ' The adjustment of working hours shall not exceed the current actual working hours ',
  },
  '-157': {
    zh: '任务工时超出最大限制',
    cht: '任務工時超出最大限制',
    en: ' work hours exceeded the maximum limit ',
  },
  '-158': {
    zh: '该文件已取消关联',
    cht: '該文件已取消關聯',
    en: ' this file has been disassociated ',
  },
  '-159': {
    zh: '角色人员数量不满足',
    cht: '角色人員數量不滿足',
    en: ' the number of role personnel is not satisfied ',
  },
  '-160': {
    zh: '项目默认角色不能变更',
    cht: '項目默認角色不能變更',
    en: ' Project default role cannot be changed ',
  },
  '-161': {
    zh: '删除失败,仅限会议发起人有删除会议权限',
    cht: '刪除失敗,僅限會議發起人有刪除會議權限',
    en:
      ' failed to delete a meeting, only the meeting sponsor has the right to delete a meeting ',
  },
  '-162': {
    zh: '获取项目默认角色id异常',
    cht: '獲取項目默認角色id異常',
    en: ' Exception to obtain project default role id ',
  },
  '-163': {
    zh: '不能删除项目创建人',
    cht: '不能刪除項目創建人',
    en: ' Cannot delete project creator ',
  },
  '-164': {
    zh: '该规则正在被引用，不可删除',
    cht: '該規則正在被引用，不可刪除',
    en: ' this rule is being referenced and cannot be deleted ',
  },
  '-165': {
    zh: '请先将时间规则禁用后删除',
    cht: '請先將時間規則禁用後刪除',
    en: ' Please disable the time rule before deleting it ',
  },
  '-166': {
    zh: '时间变量名称不可重复',
    cht: '時間變量名稱不可重複',
    en: ' time variable name cannot be repeated ',
  },
  '-167': {
    zh: '时间变量已被任务引用，不可删除',
    cht: '時間變量已被任務引用，不可刪除',
    en:
      ' the time variable has been referenced by the task and cannot be deleted ',
  },
  '-168': {
    zh: '因还有用户关联这个角色，故不可删除！',
    cht: '因還有用戶關聯這個角色，故不可刪除！',
    en:
      ' This role cannot be deleted because there are still users associated with it!',
  },
  '-169': {
    zh: '删除角色失败',
    cht: '刪除角色失敗',
    en: ' Role deletion failed ',
  },
  '-170': {
    zh: '操作人错误',
    cht: '操作人錯誤',
    en: ' Operator error ',
  },
  '-171': {
    zh: '当前审批已经开始，无法撤销',
    cht: '當前審批已經開始，無法撤銷',
    en: ' The current approval has been initiated and cannot be revoked ',
  },
  '-172': {
    zh: '未设置办理角色',
    cht: '未設置辦理角色',
    en: ' no processing role set ',
  },
  '-173': {
    zh: '无法找到办理人',
    cht: '無法找到辦理人',
    en: ' no handler can be found ',
  },
  '-174': {
    zh: '找到一个以上流程开始节点',
    cht: '找到一個以上流程開始節點',
    en: ' Find more than one process start node ',
  },
  '-175': {
    zh: '关联项已存在',
    cht: '關聯項已存在',
    en: ' association item already exists ',
  },
  '-176': {
    zh: '关联项已存在',
    cht: '關聯項已存在',
    en: ' association item already exists ',
  },
  '-177': {
    zh: '此审批需要关联会议',
    cht: '此審批需要關聯會議',
    en: ' This approval requires an associated meeting ',
  },
  '-178': {
    zh: '当前审批关联的会议尚未结束',
    cht: '當前審批關聯的會議尚未結束',
    en: ' The meeting for the current approval association has not yet ended ',
  },
  '-179': {
    zh: '此审批需要关联投票',
    cht: '此審批需要關聯投票',
    en: ' This approval requires a related vote ',
  },
  '-180': {
    zh: '当前审批关联的投票还没有结束',
    cht: '當前審批關聯的投票還沒有結束',
    en:
      ' The voting for the current approval association has not been completed ',
  },
  '-181': {
    zh: '此投票已关联一个审批',
    cht: '此投票已關聯一個審批',
    en: ' This vote has been associated with an approval ',
  },
  '-182': {
    zh: '流程定义不存在',
    cht: '流程定義不存在',
    en: ' process definition does not exist ',
  },
  '-183': {
    zh: '不能删除与项目关联的企业客户',
    cht: '不能刪除與項目關聯的企業客戶',
    en: ' Business customers associated with the project cannot be deleted ',
  },
  '-184': {
    zh: '没有匹配的流程图',
    cht: '沒有匹配的流程圖',
    en: ' no matching flowchart ',
  },
  '-185': {
    zh: '该项目已存在终止审批',
    cht: '該項目已存在終止審批',
    en: ' The project has been approved for termination ',
  },
  '-186': {
    zh: '被移交人员账号异常',
    cht: '被移交人員賬號異常',
    en: ' transferred personnel account abnormal ',
  },
  '-187': {
    zh: '发起审批失败',
    cht: '發起審批失敗',
    en: ' failed to initiate approval ',
  },
  '-188': {
    zh: '请先选择业务类型',
    cht: '請先選擇業務類型',
    en: ' Please select the business type first ',
  },
  '-189': {
    zh: '该流程正在使用，不可编辑',
    cht: '該流程正在使用，不可編輯',
    en: ' the process is in use, not editable ',
  },
  '-190': {
    zh: '请先选择项目阶段',
    cht: '請先選擇項目階段',
    en: ' Please select the project phase first ',
  },
  '-191': {
    zh:
      '该审批类型下所有流程均不可用，可前往主工作台-审批中心查看不可用原因或联系管理员修改',
    cht:
      '該審批類型下所有流程均不可用，可前往主工作臺-審批中心查看不可用原因或聯繫管理員修改',
    en:
      ' All processes under this approval type are unavailable, you can go to the main workbench - Approval Center to check the reasons for the unavailable or contact the administrator to modify ',
  },
  '-192': {
    zh: '阶段审批不可重复发起',
    cht: '階段審批不可重複發起',
    en: ' Stage approval cannot be initiated repeatedly ',
  },
  '-193': {
    zh: '当前阶段已审批通过,不可发起',
    cht: '當前階段已審批通過,不可發起',
    en: ' the current stage has been approved and cannot be initiated ',
  },
  '-194': {
    zh: '查询客户不存在',
    cht: '查詢客戶不存在',
    en: ' query customer does not exist ',
  },
  '-195': {
    zh: '已经关联任务,不能增加关联',
    cht: '已經關聯任務,不能增加關聯',
    en: ' task already associated, cannot add association ',
  },
  '-196': {
    zh: '关联任务已完成或已关闭不能关联',
    cht: '關聯任務已完成或已關閉不能關聯',
    en: ' Association task completed or closed cannot be associated ',
  },
  '-197': {
    zh: '只有任务创建人才能删除关联任务',
    cht: '只有任務創建人才能刪除關聯任務',
    en: ' Only the task creator can delete an associated task ',
  },
  '-198': {
    zh: '该任务存在前置任务未完成，不可完成此任务',
    cht: '該任務存在前置任務未完成，不可完成此任務',
    en: ' this task has a pre-task unfinished, cannot complete this task ',
  },
  '-199': {
    zh: '该任务已完成或关闭，不能添加关联任务',
    cht: '該任務已完成或關閉，不能添加關聯任務',
    en: ' This task is completed or closed, cannot add an associated task ',
  },
  '-200': {
    zh: '不可选相同任务',
    cht: '不可選相同任務',
    en: ' same task cannot be selected ',
  },
  '-201': {
    zh: '不能删除别人的评论',
    cht: '不能刪除別人的評論',
    en: " can't delete other people's comments ",
  },
  '-202': {
    zh: '客户出现重名',
    cht: '客戶出現重名',
    en: ' customer has a different name ',
  },
  '-203': {
    zh: '存在被关联的投票，不可删除',
    cht: '存在被關聯的投票，不可刪除',
    en: ' associated vote exists, cannot be deleted ',
  },
  '-204': {
    zh: '存在被关联的会议，不可删除',
    cht: '存在被關聯的會議，不可刪除',
    en: ' an associated conference exists and cannot be deleted ',
  },
  '-205': {
    zh: '该业务类型已被引用，无法删除',
    cht: '該業務類型已被引用，無法刪除',
    en: ' this service type has been referenced and cannot be deleted ',
  },
  '-206': {
    zh: '部分阶段已被引用，无法删除',
    cht: '部分階段已被引用，無法刪除',
    en: ' part of the stage has been referenced and cannot be deleted ',
  },
  '-207': {
    zh: '只能删除自己创建的任务',
    cht: '只能刪除自己創建的任務',
    en: ' Only self-created tasks can be deleted ',
  },
  '-208': {
    zh: '只能关闭自己创建的任务',
    cht: '只能關閉自己創建的任務',
    en: ' can only close self-created tasks ',
  },
  '-209': {
    zh: '您没有删除任务的权限',
    cht: '您沒有刪除任務的權限',
    en: ' You do not have permission to delete the task ',
  },
  '-210': {
    zh: '您没有关闭任务的权限',
    cht: '您沒有關閉任務的權限',
    en: ' You do not have permission to close the task ',
  },
  '-211': {
    zh: '批量关闭任务',
    cht: '批量關閉任務',
    en: ' Batch shutdown task ',
  },
  '-212': {
    zh: '编辑失败、您无编辑权限或任务为以下状态：已完成，已删除',
    cht: '編輯失敗、您無編輯權限或任務爲以下狀態：已完成，已刪除',
    en:
      ' Editing failed, you have no editing rights, or the task is in the following status: Completed, Deleted ',
  },
  '-213': {
    zh: '全部任务标记失败',
    cht: '全部任務標記失敗',
    en: ' all task markers failed ',
  },
  '-214': {
    zh: '有多个流程图同时使用',
    cht: '有多個流程圖同時使用',
    en: ' multiple flowcharts are used at the same time ',
  },
  '-215': {
    zh: '审批人异常',
    cht: '審批人異常',
    en: ' Approver exception ',
  },
  '-216': {
    zh: '请先选择审批人',
    cht: '請先選擇審批人',
    en: ' Please select the approver first ',
  },
  '-217': {
    zh: '流程图不完整无法启用审核，请补充流程图',
    cht: '流程圖不完整無法啓用審覈，請補充流程圖',
    en:
      ' Incomplete flow chart cannot enable audit, please supplement flow chart ',
  },
  '-218': {
    zh: '该业务类型含目录模板，请处理后重试',
    cht: '該業務類型含目錄模板，請處理後重試',
    en:
      ' This service type includes directory template, please process and try again ',
  },
  '-219': {
    zh: '业务类型不可用',
    cht: '業務類型不可用',
    en: ' Business type unavailable ',
  },
  '-220': {
    zh: '项目负责人或成员无审批新增人员权限，暂无法加入，请联系管理员',
    cht: '項目負責人或成員無審批新增人員權限，暫無法加入，請聯繫管理員',
    en:
      ' The project leader or members do not have the permission to approve new personnel, temporarily unable to join, please contact the administrator ',
  },
  '-221': {
    zh: '任务已被删除',
    cht: '任務已被刪除',
    en: ' Task deleted ',
  },
  '-222': {
    zh: '上个导出任务未完成，请稍后再试',
    cht: '上個導出任務未完成，請稍後再試',
    en: ' Last export task not completed, please try again later ',
  },
  '-223': {
    zh: '密码错误',
    cht: '密碼錯誤',
    en: ' incorrect password ',
  },
  '-224': {
    zh: '不是组织拥有者,无权操作',
    cht: '不是組織擁有者,無權操作',
    en: ' not organization owner, no right to operate ',
  },
  '-225': {
    zh: '被移交人已拥有试用版组织，无法移交',
    cht: '被移交人已擁有試用版組織，無法移交',
    en:
      ' the transferee already has a trial organization and cannot be transferred ',
  },
  '-226': {
    zh: '移交失败',
    cht: '移交失敗',
    en: ' handover failure ',
  },
  '-227': {
    zh: '移交失败',
    cht: '移交失敗',
    en: ' handover failure ',
  },
  '-228': {
    zh: '组织无法移交给本人',
    cht: '組織無法移交給本人',
    en: ' The organization cannot be transferred to the person ',
  },
  '-229': {
    zh: '项目不存在',
    cht: '項目不存在',
    en: ' project does not exist ',
  },
  '-230': {
    zh: '请先移交本组织内的所有项目',
    cht: '請先移交本組織內的所有項目',
    en: ' Please hand over all projects within the Organization first ',
  },
  '-231': {
    zh: '该分类名称已存在，请重新填写',
    cht: '該分類名稱已存在，請重新填寫',
    en: ' the category name already exists, please fill in again ',
  },
  '-232': {
    zh: '暂无对应权限，请联系管理员！',
    cht: '暫無對應權限，請聯繫管理員！',
    en: ' No corresponding permission, please contact the administrator!',
  },
  '-233': {
    zh: '新建项目成功，人员邀请失败，请进入项目成员页面重新邀请',
    cht: '新建項目成功，人員邀請失敗，請進入項目成員頁面重新邀請',
    en:
      ' New project succeeded, personnel invitation failed, please go to the project member page to re-invite ',
  },
  '-234': {
    zh: '获取客服信息失败',
    cht: '獲取客服信息失敗',
    en: ' failed to obtain customer service information ',
  },
  '-235': {
    zh: '修改客服状态失败',
    cht: '修改客服狀態失敗',
    en: ' Failed to modify customer service status ',
  },
  '-236': {
    zh: '用户断线重连失败',
    cht: '用戶斷線重連失敗',
    en: ' User disconnection failed to reconnect ',
  },
  '-237': {
    zh: '分类已删除，不可移动',
    cht: '分類已刪除，不可移動',
    en: ' Classification deleted, cannot be moved ',
  },
  '-238': {
    zh: '标签已删除，不可移动',
    cht: '標籤已刪除，不可移動',
    en: ' label removed, cannot be moved ',
  },
  '-239': {
    zh: '不能删除别人的正式回复',
    cht: '不能刪除別人的正式回覆',
    en: " can't delete someone's formal reply ",
  },
  '-240': {
    zh: '选择的标签分类不存在，请重新选择！',
    cht: '選擇的標籤分類不存在，請重新選擇！',
    en: ' The selected label category does not exist, please reselect!',
  },
  '-241': {
    zh:
      '由于您已不在文件对应组织，此次未上传新版本。如果您需要找回文件版本请联系售后010-57235595',
    cht:
      '由於您已不在文件對應組織，此次未上傳新版本。如果您需要找回文件版本請聯繫售後010-57235595',
    en:
      ' Because you are no longer in the file organization, no new version has been uploaded at this time. If you need to retrieve the document version, please contact 010-57235595',
  },
  '-242': {
    zh:
      '由于您已不在文件对应项目，此次未上传新版本。如果您需要找回文件版本请联系售后010-57235595',
    cht:
      '由於您已不在文件對應項目，此次未上傳新版本。如果您需要找回文件版本請聯繫售後010-57235595',
    en:
      ' Since you are no longer in the corresponding project of the file, no new version has been uploaded this time. If you need to retrieve the document version, please contact 010-57235595',
  },
  '-243': {
    zh: '收藏失败，最多收藏50个项目',
    cht: '收藏失敗，最多收藏50個項目',
    en: ' Collection failed, maximum collection 50 items ',
  },
  '-244': {
    zh: '保存失败，阶段名称不支持输入特殊字符',
    cht: '保存失敗，階段名稱不支持輸入特殊字符',
    en: ' Save failed, phase name does not support special characters ',
  },
  '-245': {
    zh: '当前版本不允许编辑该类型日志',
    cht: '當前版本不允許編輯該類型日誌',
    en: ' the current version does not allow editing this type of log ',
  },
  '-246': {
    zh: '模版已删除，刷新模版列表',
    cht: '模版已刪除，刷新模版列表',
    en: ' template removed, refresh template list ',
  },
  '-247': {
    zh: '模版已禁用，刷新模版列表',
    cht: '模版已禁用，刷新模版列表',
    en: ' Template disabled, refresh template list ',
  },
  '-248': {
    zh: '当前模板包含不支持控件，app暂不支持引用此模板',
    cht: '當前模板包含不支持控件，app暫不支持引用此模板',
    en:
      ' the current template contains unsupported controls, app does not support reference to this template yet ',
  },
  '-249': {
    zh: '仅能查看此篇日志，无法评论',
    cht: '僅能查看此篇日誌，無法評論',
    en: ' Can only view this log, cannot comment ',
  },
  '-250': {
    zh: '仅能查看此篇日志，无法定位',
    cht: '僅能查看此篇日誌，無法定位',
    en: ' can only view this log, cannot locate ',
  },
  '-251': {
    zh: '接收人为0人,请调整后创建',
    cht: '接收人爲0人,請調整後創建',
    en: ' The receiver is 0, please adjust and create ',
  },
  '-252': {
    zh: '操作ES出现异常',
    cht: '操作ES出現異常',
    en: ' Abnormal operation ES ',
  },
  '-253': {
    zh: '内部查询用户操作，ES出现异常',
    cht: '內部查詢用戶操作，ES出現異常',
    en: ' internal query user operation, ES is abnormal ',
  },
  '-254': {
    zh: '项目不能移交给本人',
    cht: '項目不能移交給本人',
    en: ' the project cannot be transferred to me ',
  },
  '-255': {
    zh: '任务分享失败',
    cht: '任務分享失敗',
    en: ' Task sharing failure ',
  },
  '-256': {
    zh: '任务名称长度超出限制',
    cht: '任務名稱長度超出限制',
    en: ' Task name Length out of limit ',
  },
  '-257': {
    zh: '批量打开任务失败',
    cht: '批量打開任務失敗',
    en: ' Failed to batch open task ',
  },
  '-258': {
    zh: '暂无任务导出',
    cht: '暫無任務導出',
    en: ' No task export yet ',
  },
  '-259': {
    zh: '已取消完成',
    cht: '已取消完成',
    en: ' cancelled completed ',
  },
  '-260': {
    zh: '无编辑任务标签权限，请联系项目管理员分配',
    cht: '無編輯任務標籤權限，請聯繫項目管理員分配',
    en:
      ' No edit task label permission, please contact the project administrator to assign ',
  },
  '-261': {
    zh: '任务不能为空',
    cht: '任務不能爲空',
    en: ' task cannot be empty ',
  },
  '-262': {
    zh: '任务不存在',
    cht: '任務不存在',
    en: ' The task does not exist ',
  },
  '-263': {
    zh: '暂无对应权限，请联系管理员！',
    cht: '暫無對應權限，請聯繫管理員！',
    en: ' No corresponding permission, please contact the administrator!',
  },
  '-264': {
    zh: '不是创建人或者没有编辑权限',
    cht: '不是創建人或者沒有編輯權限',
    en: ' not the creator or has no editing rights ',
  },
  '-265': {
    zh: '短信发送成功',
    cht: '短信發送成功',
    en: ' SMS sent successfully ',
  },
  '-266': {
    zh: '验证码已发送',
    cht: '驗證碼已發送',
    en: ' Verification code sent ',
  },
  '-267': {
    zh: '今日验证次数已达上限,请使用密码登录',
    cht: '今日驗證次數已達上限,請使用密碼登錄',
    en:
      ' The number of authentications today has reached the upper limit, please use password login ',
  },
  '-268': {
    zh: '短信发送失败',
    cht: '短信發送失敗',
    en: ' SMS sending failed ',
  },
  '-269': {
    zh: '该组织已有业务类型，不可导入新业务类型',
    cht: '該組織已有業務類型，不可導入新業務類型',
    en:
      ' The organization already has a service type, no new service type can be imported ',
  },
  '-270': {
    zh: '您未绑定手机号,请先绑定手机号',
    cht: '您未綁定手機號,請先綁定手機號',
    en:
      ' You do not bind the mobile phone number, please bind the mobile phone number first ',
  },
  '-271': {
    zh: '授权失败',
    cht: '授權失敗',
    en: ' Authorization failure ',
  },
  '-272': {
    zh: '文件不存在',
    cht: '文件不存在',
    en: ' file does not exist ',
  },
  '-273': {
    zh: '文件已删除',
    cht: '文件已刪除',
    en: ' File deleted ',
  },
  '-274': {
    zh: '查询讨论文件时出错',
    cht: '查詢討論文件時出錯',
    en: ' error querying discussion file ',
  },
  '-275': {
    zh: '原讨论文件都已删除',
    cht: '原討論文件都已刪除',
    en: ' all original discussion papers deleted ',
  },
  '-276': {
    zh: '源目录已不存在',
    cht: '源目錄已不存在',
    en: ' source directory no longer exists ',
  },
  '-277': {
    zh: '结束时间不能早于开始时间',
    cht: '結束時間不能早於開始時間',
    en: ' the end time cannot be earlier than the start time ',
  },
  '-278': {
    zh: '有项目时间信息不完整，是否完善?',
    cht: '有項目時間信息不完整，是否完善?',
    en: ' There is project time information is incomplete, is it complete?',
  },
  '-279': {
    zh: '时间不能为空',
    cht: '時間不能爲空',
    en: ' Time cannot be empty ',
  },
  '-280': {
    zh: '开始类型和结束类型不一致',
    cht: '開始類型和結束類型不一致',
    en: ' start type and end type are inconsistent ',
  },
  '-281': {
    zh: '任务的重复周期参数有误',
    cht: '任務的重複週期參數有誤',
    en: ' the task repetition period parameter is incorrect ',
  },
  '-282': {
    zh: '锁定的文件不能重命名',
    cht: '鎖定的文件不能重命名',
    en: ' locked file cannot be renamed ',
  },
  '-283': {
    zh: '修改文件审批状态失败',
    cht: '修改文件審批狀態失敗',
    en: ' Failed to modify document approval status ',
  },
  '-284': {
    zh: '同一文件夹内不允许存在多个索引文件',
    cht: '同一文件夾內不允許存在多個索引文件',
    en: ' Do not allow more than one index file in the same folder ',
  },
  '-285': {
    zh: '阶段任务模板为空',
    cht: '階段任務模板爲空',
    en: ' phase task template is empty ',
  },
  '-286': {
    zh: '当前并行任务较多，请稍后重试。',
    cht: '當前並行任務較多，請稍後重試。',
    en: ' there are many parallel tasks currently. Please try again later.',
  },
  '-287': {
    zh: '项目已经被删除',
    cht: '項目已經被刪除',
    en: ' the item has been deleted ',
  },
  '-288': {
    zh: '您无法进入该项目',
    cht: '您無法進入該項目',
    en: ' You cannot enter the program ',
  },
  '-289': {
    zh: '您不是该项目成员',
    cht: '您不是該項目成員',
    en: ' You are not a member of the project ',
  },
  '-290': {
    zh: '项目文件不存在',
    cht: '項目文件不存在',
    en: ' Project file does not exist ',
  },
  '-291': {
    zh: '底稿文件不存在',
    cht: '底稿文件不存在',
    en: ' manuscript file does not exist ',
  },
  '-292': {
    zh: '邀请人员为空',
    cht: '邀請人員爲空',
    en: ' invitation is empty ',
  },
  '-293': {
    zh: '审批中的文件不能删除，请重新选择',
    cht: '審批中的文件不能刪除，請重新選擇',
    en: ' Files under approval cannot be deleted, please reselect ',
  },
  '-294': {
    zh: '审批中的文件不能重命名，请重新选择',
    cht: '審批中的文件不能重命名，請重新選擇',
    en: ' the approved document cannot be renamed, please re-select ',
  },
  '-295': {
    zh: '审批中的文件不能上传新版本，请重新选择',
    cht: '審批中的文件不能上傳新版本，請重新選擇',
    en:
      ' New version of the approved document cannot be uploaded, please reselect ',
  },
  '-296': {
    zh: '该审批已关联审批',
    cht: '該審批已關聯審批',
    en: ' This approval has been associated with approval ',
  },
  '-297': {
    zh: '该审批需要关联审批',
    cht: '該審批需要關聯審批',
    en: ' This approval requires associated approval ',
  },
  '-298': {
    zh: '关联审批正在审批中，审批通过后方可进行！',
    cht: '關聯審批正在審批中，審批通過後方可進行！',
    en:
      ' Association approval is being approved, and can only be carried out after approval!',
  },
  '-299': {
    zh: '关联审批被驳回/撤销，请重新关联审批！',
    cht: '關聯審批被駁回/撤銷，請重新關聯審批！',
    en:
      ' Association approval rejected/revoked, please re-association approval!',
  },
  '-300': {
    zh: '该审批已撤销/未通过',
    cht: '該審批已撤銷/未通過',
    en: ' the approval has been revoked/not approved ',
  },
  '-301': {
    zh: '操作失败',
    cht: '操作失敗',
    en: ' Operation failed ',
  },
  '-302': {
    zh: '操作失败',
    cht: '操作失敗',
    en: ' Operation failed ',
  },
  '-303': {
    zh: '文件类型/组织被删除',
    cht: '文件類型/組織被刪除',
    en: ' file type/organization deleted ',
  },
  '-304': {
    zh: '还原文件失败',
    cht: '還原文件失敗',
    en: ' failed to restore file ',
  },
  '-305': {
    zh: '文件已还原，请进入项目文档查看',
    cht: '文件已還原，請進入項目文檔查看',
    en:
      ' the file has been restored, please go to the project document to view ',
  },
  '-306': {
    zh: '部分对象的原路径不存在,请选择还原路径',
    cht: '部分對象的原路徑不存在,請選擇還原路徑',
    en:
      ' the original path of some objects does not exist, please select the restore path ',
  },
  '-307': {
    zh: '目录已被删除,请重新选择',
    cht: '目錄已被刪除,請重新選擇',
    en: ' directory has been deleted, please reselect ',
  },
  '-308': {
    zh: '当前项目没有可归档的阶段',
    cht: '當前項目沒有可歸檔的階段',
    en: ' There are no archivable phases in the current project ',
  },
  '-309': {
    zh: '没有权限',
    cht: '沒有權限',
    en: ' no permission ',
  },
  '-310': {
    zh: '通过人名检索无匹配的记录',
    cht: '通過人名檢索無匹配的記錄',
    en: ' Search for unmatched records by name ',
  },
  '-311': {
    zh: '文件无法操作，已选中的文件或文件夹包含已锁定状态',
    cht: '文件無法操作，已選中的文件或文件夾包含已鎖定狀態',
    en:
      ' file cannot be operated, selected file or folder contains locked state ',
  },
  '-312': {
    zh: '锁定的文件或文件夹内含有锁定的文件，不可重命名',
    cht: '鎖定的文件或文件夾內含有鎖定的文件，不可重命名',
    en: ' locked file or folder contains locked files, cannot be renamed ',
  },
  '-313': {
    zh: '锁定的文件或文件夹内含有锁定的文件，不可删除',
    cht: '鎖定的文件或文件夾內含有鎖定的文件，不可刪除',
    en: ' locked file or folder contains locked files, cannot be deleted ',
  },
  '-314': {
    zh: '锁定的文件或文件夹内含有锁定的文件，不可上传新版本',
    cht: '鎖定的文件或文件夾內含有鎖定的文件，不可上傳新版本',
    en:
      ' locked file or folder contains locked files, cannot upload new version ',
  },
  '-315': {
    zh: '剪切文件中包含目标文件夹，请重新剪切',
    cht: '剪切文件中包含目標文件夾，請重新剪切',
    en: ' the clipping file contains the target folder, please re-clipping ',
  },
  '-316': {
    zh: '同目录下文件无法剪切',
    cht: '同目錄下文件無法剪切',
    en: ' files in same directory cannot be cut ',
  },
  '-317': {
    zh: '选中的文件夹无法剪切到当前文件下',
    cht: '選中的文件夾無法剪切到當前文件下',
    en: ' the selected folder cannot be clipped to the current file ',
  },
  '-318': {
    zh: '归档的文件无法粘贴为底稿',
    cht: '歸檔的文件無法粘貼爲底稿',
    en: ' Archived document cannot be pasted into manuscript ',
  },
  '-319': {
    zh: '没有删除引用目录的权限',
    cht: '沒有刪除引用目錄的權限',
    en: ' no permission to delete referenced directories ',
  },
  '-320': {
    zh: '没有删除底稿目录的权限',
    cht: '沒有刪除底稿目錄的權限',
    en: ' no permission to delete the manuscript directory ',
  },
  '-321': {
    zh: '没有删除底稿目录的权限',
    cht: '沒有刪除底稿目錄的權限',
    en: ' no permission to delete the manuscript directory ',
  },
  '-322': {
    zh: '操作mongoDB出现异常',
    cht: '操作mongoDB出現異常',
    en: ' mongoDB operation exception ',
  },
  '-323': {
    zh: '操作Fastdfs出现异常',
    cht: '操作Fastdfs出現異常',
    en: ' Error in Fastdfs operation ',
  },
  '-324': {
    zh: '编辑上锁的文件，无法解锁，需要联系锁定人解锁',
    cht: '編輯上鎖的文件，無法解鎖，需要聯繫鎖定人解鎖',
    en: ' Edit locked file, cannot unlock, need to contact lock person unlock ',
  },
  '-325': {
    zh: '用户插入失败',
    cht: '用戶插入失敗',
    en: ' User insertion failed ',
  },
  '-326': {
    zh: '初始化底稿上传目录成功',
    cht: '初始化底稿上傳目錄成功',
    en: ' initial copy upload directory successful ',
  },
  '-327': {},
  '-328': {
    zh: '请导入从系统中下载的模板',
    cht: '請導入從系統中下載的模板',
    en: ' Please import the template you downloaded from the system ',
  },
  '-329': {
    zh: '文件插入到项目文档失败',
    cht: '文件插入到項目文檔失敗',
    en: ' failed to insert file into project document ',
  },
  '-330': {
    zh: '有字段超出最大填写位数',
    cht: '有字段超出最大填寫位數',
    en: ' field exceeds maximum number of fields ',
  },
  '-331': {
    zh: '有重要信息没有填写',
    cht: '有重要信息沒有填寫',
    en: ' Important information not filled in ',
  },
  '-332': {
    zh: '缺少需要复制的流程图',
    cht: '缺少需要複製的流程圖',
    en: ' Missing flowchart to be copied ',
  },
  '-333': {
    zh: '创建Excel工作薄为空！',
    cht: '創建Excel工作薄爲空！',
    en: ' Create an empty Excel workbook!',
  },
  '-334': {
    zh: '上传文件不符',
    cht: '上傳文件不符',
    en: ' upload file inconsistent ',
  },
  '-335': {
    zh: '待审文件存在锁定中的文件',
    cht: '待審文件存在鎖定中的文件',
    en: ' Files in the lock for pending review ',
  },
  '-336': {
    zh: '撤销失败',
    cht: '撤銷失敗',
    en: ' undo failure ',
  },
  '-337': {
    zh: '请选择可审批的文件',
    cht: '請選擇可審批的文件',
    en: ' Please select documents for approval ',
  },
  '-338': {
    zh: '请选择审批通过的文件',
    cht: '請選擇審批通過的文件',
    en: ' Please select approved documents ',
  },
  '-339': {
    zh: '添加文件审批意见失败',
    cht: '添加文件審批意見失敗',
    en: ' Failed to add file approval comment ',
  },
  '-340': {
    zh: '审批文件失败',
    cht: '審批文件失敗',
    en: ' document approval failure ',
  },
  '-341': {
    zh: '请对未审批的文件进行审批',
    cht: '請對未審批的文件進行審批',
    en: ' Please approve unapproved documents ',
  },
  '-342': {
    zh: '该审批已经结束，不可对文件进行审批',
    cht: '該審批已經結束，不可對文件進行審批',
    en: ' This approval has been completed, the document cannot be approved ',
  },
  '-343': {
    zh: '非该审批的审批人',
    cht: '非該審批的審批人',
    en: ' not the approver of such approval ',
  },
  '-344': {
    zh: '没有审批文件',
    cht: '沒有審批文件',
    en: ' no approval document ',
  },
  '-345': {
    zh: '不用走审批',
    cht: '不用走審批',
    en: ' no need for approval ',
  },
  '-346': {
    zh: '限制文件类型上传',
    cht: '限制文件類型上傳',
    en: ' Limit file type upload ',
  },
  '-347': {
    zh: '该审批任务不存在',
    cht: '該審批任務不存在',
    en: ' this approval task does not exist ',
  },
  '-348': {
    zh: '提交审批失败',
    cht: '提交審批失敗',
    en: ' Submission failed for approval ',
  },
  '-349': {
    zh: '当前文件都是不通过',
    cht: '當前文件都是不通過',
    en: ' current files are not approved ',
  },
  '-350': {
    zh: '当前项目存在没有审批完成的归档审批',
    cht: '當前項目存在沒有審批完成的歸檔審批',
    en:
      ' The current project has an archival approval that has not been completed ',
  },
  '-351': {
    zh: '选择的文件已被删除',
    cht: '選擇的文件已被刪除',
    en: ' selected file has been deleted ',
  },
  '-352': {
    zh: '当前节点审批已完成',
    cht: '當前節點審批已完成',
    en: ' current node approval completed ',
  },
  '-353': {
    zh: '请选择可审批的目录',
    cht: '請選擇可審批的目錄',
    en: ' Please select approved directory ',
  },
  '-354': {
    zh: '选择的目录已被删除',
    cht: '選擇的目錄已被刪除',
    en: ' selected directory has been deleted ',
  },
  '-355': {
    zh: '请选择审批通过的目录',
    cht: '請選擇審批通過的目錄',
    en: ' Please select approved directory ',
  },
  '-356': {
    zh: '该审批已经结束，不可对文件进行审批',
    cht: '該審批已經結束，不可對文件進行審批',
    en: ' This approval has ended, the document cannot be approved ',
  },
  '-357': {
    zh: '添加文件审批意见失败',
    cht: '添加文件審批意見失敗',
    en: ' Failed to add document approval comment ',
  },
  '-358': {
    zh: '请对未审批的目录进行审批',
    cht: '請對未審批的目錄進行審批',
    en: ' Please approve unapproved directories ',
  },
  '-359': {
    zh: '当前目录都是不通过',
    cht: '當前目錄都是不通過',
    en: ' current directory is not passed ',
  },
  '-360': {
    zh: '没有审批目录',
    cht: '沒有審批目錄',
    en: ' no approval list ',
  },
  '-361': {
    zh: '修改目录审批状态失败',
    cht: '修改目錄審批狀態失敗',
    en: ' Failed to modify directory approval status ',
  },
  '-362': {
    zh: '选中的文件夹被锁定，不可重命名',
    cht: '選中的文件夾被鎖定，不可重命名',
    en: ' the selected folder is locked and cannot be renamed ',
  },
  '-363': {
    zh: '文件已被删除',
    cht: '文件已被刪除',
    en: ' File has been deleted ',
  },
  '-364': {
    zh: '目录已被删除',
    cht: '目錄已被刪除',
    en: ' directory has been deleted ',
  },
  '-365': {
    zh: '该审批类型名称已存在',
    cht: '該審批類型名稱已存在',
    en: ' the approval type name already exists ',
  },
  '-366': {
    zh: '项目审批/普通审批不可编辑、删除、禁用',
    cht: '項目審批/普通審批不可編輯、刪除、禁用',
    en:
      ' Project Approval/General approval cannot be edited, deleted or disabled ',
  },
  '-367': {
    zh: '当前版本不可添加项目审批',
    cht: '當前版本不可添加項目審批',
    en: ' current version cannot add project approval ',
  },
  '-368': {
    zh: '当前目录含文件，请处理文件后重试',
    cht: '當前目錄含文件，請處理文件後重試',
    en:
      ' current directory contains files, please process the files and try again ',
  },
  '-369': {
    zh: '当前目录含审批中目录，请完成对应目录审批后重试',
    cht: '當前目錄含審批中目錄，請完成對應目錄審批後重試',
    en:
      ' The current directory contains the approved directory, please complete the corresponding directory approval and try again ',
  },
  '-370': {
    zh: '总文件大小不能超过600M',
    cht: '總文件大小不能超過600M',
    en: ' total file size cannot exceed 600M',
  },
  '-371': {
    zh: '创建文件夹失败',
    cht: '創建文件夾失敗',
    en: ' folder creation failed ',
  },
  '-372': {
    zh: '该合并文件已超过 600MB，请前往 PC 端下载',
    cht: '該合併文件已超過 600MB，請前往 PC 端下載',
    en: ' The merged file has exceeded 600MB, please download it on PC ',
  },
  '-373': {
    zh: '打包文件出错，请稍后重试',
    cht: '打包文件出錯，請稍後重試',
    en: ' error packing file, please try again later ',
  },
  '-374': {
    zh: '该项目存在历史（文件/目录）的审批记录，不可引用目录',
    cht: '該項目存在歷史（文件/目錄）的審批記錄，不可引用目錄',
    en:
      ' The project has a history (file/directory) approval record, cannot refer to the directory ',
  },
  '-375': {
    zh: '角色名称已存在',
    cht: '角色名稱已存在',
    en: ' Role name already exists ',
  },
  '-376': {
    zh: '该项目角色已被审批流程引用，不可删除！',
    cht: '該項目角色已被審批流程引用，不可刪除！',
    en:
      ' This project role has been referenced by the approval process and cannot be deleted!',
  },
  '-377': {
    zh: '缺少要复制的角色',
    cht: '缺少要複製的角色',
    en: ' missing role to copy ',
  },
  '-378': {
    zh: '当前项目已完成',
    cht: '當前項目已完成',
    en: ' current project completed ',
  },
  '-379': {
    zh: '新建失败',
    cht: '新建失敗',
    en: ' New failed ',
  },
  '-380': {
    zh: '新建成功',
    cht: '新建成功',
    en: ' New success ',
  },
  '-381': {
    zh: '该项目类型已被删除，无法复制',
    cht: '該項目類型已被刪除，無法複製',
    en: ' This item type has been deleted and cannot be copied ',
  },
  '-382': {
    zh: '存在文件已被借阅/处于借阅中、请重试',
    cht: '存在文件已被借閱/處於借閱中、請重試',
    en: ' existing file has been borrowed/is on loan, please try again ',
  },
  '-383': {
    zh: '跨组织粘贴的内容为空',
    cht: '跨組織粘貼的內容爲空',
    en: ' the content pasted across organizations is empty ',
  },
  '-384': {
    zh: '存在文件处于跨组织粘贴中，无法删除&剪切',
    cht: '存在文件處於跨組織粘貼中，無法刪除&剪切',
    en: ' existing file in cross-organization paste, unable to delete & cut ',
  },
  '-385': {
    zh: '粘贴任务失败',
    cht: '粘貼任務失敗',
    en: ' paste task failed ',
  },
  '-386': {
    zh: '该审批已通过,请查看审批记录',
    cht: '該審批已通過,請查看審批記錄',
    en: ' The approval has been approved, please check the approval record ',
  },
  '-387': {
    zh: '该审批已终止',
    cht: '該審批已終止',
    en: ' This approval has been terminated ',
  },
  '-388': {
    zh: '当前审批中的任务不存在',
    cht: '當前審批中的任務不存在',
    en: ' the currently approved task does not exist ',
  },
  '-389': {
    zh: '您已完成审批',
    cht: '您已完成審批',
    en: ' You have completed the approval ',
  },
  '-390': {
    zh: '复制的内容已经过期，请重新复制',
    cht: '複製的內容已經過期，請重新複製',
    en: ' copied content has expired, please copy again ',
  },
  '-391': {
    zh: '当前操作失败,操作文件的上级或者下级正在剪切中',
    cht: '當前操作失敗,操作文件的上級或者下級正在剪切中',
    en:
      ' Current operation failed, parent or child of operation file is clipping ',
  },
  '-392': {
    zh: '当前操作失败,目标文件夹正在剪切中',
    cht: '當前操作失敗,目標文件夾正在剪切中',
    en: ' Current operation failed, destination folder is clipping ',
  },
  '-393': {
    zh: '中止保存，任务文件夹名称重复',
    cht: '中止保存，任務文件夾名稱重複',
    en: ' abort save, duplicate task folder name ',
  },
  '-394': {
    zh: '模板已被删除',
    cht: '模板已被刪除',
    en: ' template has been removed ',
  },
  '-395': {
    zh: '该用户已在组织内',
    cht: '該用戶已在組織內',
    en: ' the user is already in the organization ',
  },
  '-396': {
    zh: '已发送注册邀请',
    cht: '已發送註冊邀請',
    en: ' Registration invitation sent ',
  },
  '-397': {
    zh: '审核状态已变更，无法操作',
    cht: '審覈狀態已變更，無法操作',
    en: ' Audit status has changed, cannot operate ',
  },
  '-398': {
    zh: '操作类型错误',
    cht: '操作類型錯誤',
    en: ' Operation type error ',
  },
  '-399': {
    zh: '人员已满，请升级',
    cht: '人員已滿，請升級',
    en: ' Staff full, please upgrade ',
  },
  '-400': {
    zh: '邀请链接已失效，请联系管理员重新发送邀请',
    cht: '邀請鏈接已失效，請聯繫管理員重新發送邀請',
    en:
      ' Invitation link is invalid, please contact administrator to resend the invitation ',
  },
  '-401': {
    zh: '请先移交组织',
    cht: '請先移交組織',
    en: ' Please hand over the organization first ',
  },
  '-402': {
    zh: '链接不存在',
    cht: '鏈接不存在',
    en: ' link does not exist ',
  },
  '-403': {
    zh: '组织已不存在',
    cht: '組織已不存在',
    en: ' organization no longer exists ',
  },
  '-404': {
    zh: 'CRM接口调用异常',
    cht: 'CRM接口調用異常',
    en: 'CRM interface call exception ',
  },
  '-405': {
    zh: '成员已在邀请中',
    cht: '成員已在邀請中',
    en: ' members are invited ',
  },
  '-406': {
    zh: '成员已在项目中',
    cht: '成員已在項目中',
    en: ' member already in the project ',
  },
  '-407': {
    zh: '添加失败，超出当前组织成员可用席位数量',
    cht: '添加失敗，超出當前組織成員可用席位數量',
    en:
      ' Add failed to exceed the number of available seats for current organization members ',
  },
  '-408': {
    zh: '当前用户已有未付费组织',
    cht: '當前用戶已有未付費組織',
    en: ' Current user has unpaid organization ',
  },
  '-409': {
    zh: '该组织不存在',
    cht: '該組織不存在',
    en: ' the organization does not exist ',
  },
  '-410': {
    zh: '该组织空间已满',
    cht: '該組織空間已滿',
    en: ' the organization is full ',
  },
  '-411': {
    zh: '邀请失效',
    cht: '邀請失效',
    en: ' Invitation expired ',
  },
  '-412': {
    zh: '创建组织异常',
    cht: '創建組織異常',
    en: ' Create Organization Exception ',
  },
  '-413': {
    zh: 'CRM更新用户信息失败',
    cht: 'CRM更新用戶信息失敗',
    en: 'CRM failed to update user information ',
  },
  '-414': {
    zh: 'CRM删除组织失败',
    cht: 'CRM刪除組織失敗',
    en: 'CRM failed to delete organization ',
  },
  '-415': {
    zh: 'CRM账号密码验证失败',
    cht: 'CRM賬號密碼驗證失敗',
    en: 'CRM account password verification failed ',
  },
  '-416': {
    zh: '邀请中成员删除失败',
    cht: '邀請中成員刪除失敗',
    en: ' failed to remove member from invitation ',
  },
  '-417': {
    zh: '已拒绝',
    cht: '已拒絕',
    en: ' rejected ',
  },
  '-418': {
    zh: '已同意',
    cht: '已同意',
    en: ' agreed ',
  },
  '-419': {
    zh: '项目已删除',
    cht: '項目已刪除',
    en: ' Item deleted ',
  },
  '-420': {
    zh: '用户退出组织失败',
    cht: '用戶退出組織失敗',
    en: ' User failed to exit organization ',
  },
  '-421': {
    zh: '导出任务正在进行,请1分钟后再次进行',
    cht: '導出任務正在進行,請1分鐘後再次進行',
    en: ' Export task in progress, please try again in 1 minute ',
  },
  '-422': {
    zh: '用户不存在',
    cht: '用戶不存在',
    en: ' user does not exist ',
  },
  '-423': {
    zh: 'CRM获取组织对应的crmId集合失败',
    cht: 'CRM獲取組織對應的crmId集合失敗',
    en:
      'CRM failed to obtain the set of crmId corresponding to the organization ',
  },
  '-424': {
    zh: '获取用户列表配置失败',
    cht: '獲取用戶列表配置失敗',
    en: ' Failed to obtain user list configuration ',
  },
  '-425': {
    zh: '获取用户功能区配置失败',
    cht: '獲取用戶功能區配置失敗',
    en: ' Failed to obtain user ribbon configuration ',
  },
  '-426': {
    zh: '该消息不存在',
    cht: '該消息不存在',
    en: ' the message does not exist ',
  },
  '-427': {
    zh: '该消息无法查询未读列表',
    cht: '該消息無法查詢未讀列表',
    en: ' the message cannot be queried unread list ',
  },
  '-428': {
    zh: '已超过可撤回时效',
    cht: '已超過可撤回時效',
    en: ' the time limit for revocability has expired ',
  },
  '-429': {
    zh: '消息转发异常',
    cht: '消息轉發異常',
    en: ' message forwarding exception ',
  },
  '-430': {
    zh: '未定位到最新消息，请上滑处理',
    cht: '未定位到最新消息，請上滑處理',
    en: ' Latest message not located, please scroll up for processing ',
  },
  '-431': {
    zh: '转发消息不能为空',
    cht: '轉發消息不能爲空',
    en: ' forward message cannot be empty ',
  },
  '-432': {
    zh: '机器人配置数据不存在',
    cht: '機器人配置數據不存在',
    en: ' Robot configuration data does not exist ',
  },
  '-433': {
    zh: '已存在同名机器人，请修改后重试',
    cht: '已存在同名機器人，請修改後重試',
    en:
      ' a robot with the same name already exists, please modify and try again ',
  },
  '-434': {
    zh: '机器人创建异常',
    cht: '機器人創建異常',
    en: ' Robot Creation exception ',
  },
  '-435': {
    zh: '链接未空',
    cht: '鏈接未空',
    en: ' link not empty ',
  },
  '-436': {
    zh: '站内信拉取异常',
    cht: '站內信拉取異常',
    en: ' in-station pull exception ',
  },
  '-437': {
    zh: '无可下载文件',
    cht: '無可下載文件',
    en: ' No files available for download ',
  },
  '-438': {
    zh: '批量新增试题type错误',
    cht: '批量新增試題type錯誤',
    en: ' batch added test item type error ',
  },
  '-439': {
    zh: '试题不存在',
    cht: '試題不存在',
    en: ' the question does not exist ',
  },
  '-440': {
    zh: '题库不存在',
    cht: '題庫不存在',
    en: ' question bank does not exist ',
  },
  '-441': {
    zh: '考试不存在',
    cht: '考試不存在',
    en: ' the exam does not exist ',
  },
  '-442': {
    zh: '试卷中不存在单元',
    cht: '試卷中不存在單元',
    en: ' There are no units in the paper ',
  },
  '-443': {
    zh: '单元中不存在试题',
    cht: '單元中不存在試題',
    en: ' there are no questions in the unit ',
  },
  '-444': {
    zh: '试题已被试卷引用，无法删除，请先删除对应试卷',
    cht: '試題已被試卷引用，無法刪除，請先刪除對應試卷',
    en:
      ' the test question has been quoted by the test paper and cannot be deleted, please delete the corresponding test paper first ',
  },
  '-445': {
    zh: '计算试卷规则出错',
    cht: '計算試卷規則出錯',
    en: ' error in calculating test rules ',
  },
  '-446': {
    zh: '题库中存在试题，无法删除，请先删除题库中的试题',
    cht: '題庫中存在試題，無法刪除，請先刪除題庫中的試題',
    en:
      ' there are questions in the question bank and cannot be deleted, please delete the questions in the question bank first ',
  },
  '-447': {
    zh: '试卷内最后一个单元不允许删除',
    cht: '試卷內最後一個單元不允許刪除',
    en: ' the last unit in the paper is not allowed to be deleted ',
  },
  '-448': {
    zh: '确认删除试题吗？',
    cht: '確認刪除試題嗎？',
    en: ' Are you sure to delete the question?',
  },
  '-449': {
    zh: '试卷已被考试引用，无法删除，请先删除对应考试',
    cht: '試卷已被考試引用，無法刪除，請先刪除對應考試',
    en:
      ' the paper has been referenced by the exam, cannot be deleted, please delete the corresponding exam first ',
  },
  '-450': {
    zh: '确认删除试卷吗？',
    cht: '確認刪除試卷嗎？',
    en: ' Are you sure to delete the test paper?',
  },
  '-451': {
    zh: '单元不存在',
    cht: '單元不存在',
    en: ' unit does not exist ',
  },
  '-452': {
    zh: '改动试题维护单元总分失败',
    cht: '改動試題維護單元總分失敗',
    en: ' Failed to change total score of item maintenance unit ',
  },
  '-453': {
    zh: '单元或试卷不存在',
    cht: '單元或試卷不存在',
    en: ' Unit or test does not exist ',
  },
  '-454': {
    zh: '改动单元内容维护试卷信息失败',
    cht: '改動單元內容維護試卷信息失敗',
    en: ' Failed to modify unit content to maintain test paper information ',
  },
  '-455': {
    zh: '定位考试不存在',
    cht: '定位考試不存在',
    en: ' positioning test does not exist ',
  },
  '-456': {
    zh: '定位试卷不存在',
    cht: '定位試卷不存在',
    en: ' location test paper does not exist ',
  },
  '-457': {
    zh: '此题库中不存在试题',
    cht: '此題庫中不存在試題',
    en: ' there are no questions in this question bank ',
  },
  '-458': {
    zh:
      '随机抽取需保持单元内分值一致，请使用批量改分，或将出题规则改为顺序抽取',
    cht:
      '隨機抽取需保持單元內分值一致，請使用批量改分，或將出題規則改爲順序抽取',
    en:
      ' random extraction needs to keep the same score values within the unit, please use batch conversion, or change the question rules to sequential extraction ',
  },
  '-459': {
    zh: '试卷不存在',
    cht: '試卷不存在',
    en: ' test paper does not exist ',
  },
  '-460': {
    zh: '分值超过最大值限制，最多只可设置为100分',
    cht: '分值超過最大值限制，最多隻可設置爲100分',
    en: ' the score exceeds the maximum limit, can only be set to 100 points ',
  },
  '-461': {
    zh: '拷贝考试数据失败',
    cht: '拷貝考試數據失敗',
    en: ' Failed to copy test data ',
  },
  '-462': {
    zh: '登录状态已失效',
    cht: '登錄狀態已失效',
    en: ' Login status is invalid ',
  },
  '-463': {
    zh: '无效组织',
    cht: '無效組織',
    en: ' invalid organization ',
  },
  '-464': {
    zh: '外链已失效',
    cht: '外鏈已失效',
    en: ' outer chain has failed ',
  },
  '-465': {
    zh: '外链解密异常',
    cht: '外鏈解密異常',
    en: ' outer chain decryption exception ',
  },
  '-466': {
    zh: '登录二维码已失效',
    cht: '登錄二維碼已失效',
    en: ' QR code login is invalid ',
  },
  '-467': {
    zh: '该手机号已绑定同类型账号',
    cht: '該手機號已綁定同類型賬號',
    en: ' the phone number has been bound to an account of the same type ',
  },
  '-468': {
    zh: '该手机号绑定账号失败',
    cht: '該手機號綁定賬號失敗',
    en: ' the mobile number fails to bind to the account ',
  },
  '-469': {
    zh: '该登录二维码不存在',
    cht: '該登錄二維碼不存在',
    en: ' this login QR code does not exist ',
  },
  '-470': {
    zh: '该二维码已失效',
    cht: '該二維碼已失效',
    en: ' this QR code is no longer valid ',
  },
  '-471': {
    zh: '你已不在当前组织，不能查询项目信息！',
    cht: '你已不在當前組織，不能查詢項目信息！',
    en:
      ' You are no longer in the current organization and cannot query project information!',
  },
  '-472': {
    zh: '组织不存在',
    cht: '組織不存在',
    en: ' organization does not exist ',
  },
  '-473': {
    zh: '项目不存在',
    cht: '項目不存在',
    en: ' item does not exist ',
  },
  '-474': {
    zh: '人员不在组织中',
    cht: '人員不在組織中',
    en: ' personnel not in the organization ',
  },
  '-475': {
    zh: '您不在组织中,无法进行当前操作',
    cht: '您不在組織中,無法進行當前操作',
    en:
      ' You are not in the organization and cannot perform the current operation ',
  },
  '-476': {
    zh: '该手机号已经注册',
    cht: '該手機號已經註冊',
    en: ' the phone number has been registered ',
  },
  '-477': {
    zh: '验证码校验无效',
    cht: '驗證碼校驗無效',
    en: ' verification code check invalid ',
  },
  '-478': {
    zh: '两次密码不一致',
    cht: '兩次密碼不一致',
    en: ' two passwords do not match ',
  },
  '-479': {
    zh: '此项目不存在服务记录',
    cht: '此項目不存在服務記錄',
    en: ' No service record exists for this item ',
  },
  '-480': {
    zh: '您无权限操作，请联系管理员',
    cht: '您無權限操作，請聯繫管理員',
    en:
      ' You do not have permission to operate, please contact the administrator ',
  },
  '-481': {
    zh: '账户或密码错误，请重新登录!',
    cht: '賬戶或密碼錯誤，請重新登錄!',
    en: ' Incorrect account or password, please log in again!',
  },
  '-482': {
    zh: '账号不存在',
    cht: '賬號不存在',
    en: ' Account number does not exist ',
  },
  '-483': {
    zh: '您不是群主,没有相关的权限',
    cht: '您不是羣主,沒有相關的權限',
    en: ' You are not a group owner and do not have relevant permissions ',
  },
  '-484': {
    zh: '该用户已在群聊中',
    cht: '該用戶已在羣聊中',
    en: ' the user is already in a group chat ',
  },
  '-485': {
    zh: '该链接已经失效',
    cht: '該鏈接已經失效',
    en: ' the link is no longer valid ',
  },
  '-486': {
    zh: '您已经加入该群聊',
    cht: '您已經加入該羣聊',
    en: ' You have joined the group chat ',
  },
  '-487': {
    zh: '加入群聊失败',
    cht: '加入羣聊失敗',
    en: ' failed to join a group chat ',
  },
  '-488': {
    zh: '添加人员超过群聊人数限制',
    cht: '添加人員超過羣聊人數限制',
    en: ' Add more than the group chat limit ',
  },
  '-489': {
    zh: '该会话不存在',
    cht: '該會話不存在',
    en: ' the session does not exist ',
  },
  '-490': {
    zh: '创建群聊失败，请联系管理员',
    cht: '創建羣聊失敗，請聯繫管理員',
    en: ' Failed to create group chat, please contact administrator ',
  },
  '-491': {
    zh: '您所在的群已超限，请处理后操作',
    cht: '您所在的羣已超限，請處理後操作',
    en: ' The group you are in has exceeded its limit, please handle it later ',
  },
  '-492': {
    zh: '群聊不存在',
    cht: '羣聊不存在',
    en: ' Group chat does not exist ',
  },
  '-493': {
    zh: '传入群聊人员为空',
    cht: '傳入羣聊人員爲空',
    en: ' incoming group chat member is empty ',
  },
  '-494': {
    zh: '您还未加入任何群聊或数据错误',
    cht: '您還未加入任何羣聊或數據錯誤',
    en: ' You have not joined any group chats or data errors ',
  },
  '-495': {
    zh: '处理群聊数为空或超出限制（10）',
    cht: '處理羣聊數爲空或超出限制（10）',
    en:
      ' the number of group chats processed is empty or exceeds the limit (10) ',
  },
  '-496': {
    zh: '该id没有绑定任何荣大账号',
    cht: '該id沒有綁定任何榮大賬號',
    en: ' This id is not bound to any Rongda account ',
  },
  '-497': {
    zh: '您没有可进入的项目群',
    cht: '您沒有可進入的項目羣',
    en: ' You have no program to enter ',
  },
  '-498': {
    zh: '抱歉，您未在当前项目群',
    cht: '抱歉，您未在當前項目羣',
    en: ' Sorry, you are not in the current project ',
  },
  '-499': {
    zh: '链接已失效，请联系邀请人重新发送邀请',
    cht: '鏈接已失效，請聯繫邀請人重新發送邀請',
    en:
      ' Link no longer available, please contact inviter to resend the invitation ',
  },
  '-500': {
    zh: '群聊已被解散！',
    cht: '羣聊已被解散！',
    en: ' Group chat has been disbanded!',
  },
  '-501': {
    zh: '项目正在进行中，本群不能解散哟。',
    cht: '項目正在進行中，本羣不能解散喲。',
    en: " Project in progress, we can't disband.",
  },
  '-502': {
    zh: '您已被移出群聊',
    cht: '您已被移出羣聊',
    en: ' You have been removed from the group chat ',
  },
  '-503': {
    zh: '群公告不存在',
    cht: '羣公告不存在',
    en: ' Group announcement does not exist ',
  },
  '-504': {
    zh: '同步类型不存在',
    cht: '同步類型不存在',
    en: ' synchronization type does not exist ',
  },
  '-505': {
    zh: '新建文件必须选择类型',
    cht: '新建文件必須選擇類型',
    en: ' New file must select type ',
  },
  '-506': {
    zh: '没有可下载的数据',
    cht: '沒有可下載的數據',
    en: ' No data available for download ',
  },
  '-507': {
    zh: '可用空间不足',
    cht: '可用空間不足',
    en: ' insufficient available space ',
  },
  '-508': {
    zh: '文件正在本地编辑中',
    cht: '文件正在本地編輯中',
    en: ' file being edited locally ',
  },
  '-509': {
    zh: '文件已经被手动锁定',
    cht: '文件已經被手動鎖定',
    en: ' File has been manually locked ',
  },
  '-510': {
    zh: '文件已经被系统锁定',
    cht: '文件已經被系統鎖定',
    en: ' File has been locked by the system ',
  },
  '-511': {
    zh: '没有客户文档在线编辑权限',
    cht: '沒有客戶文檔在線編輯權限',
    en: ' no online editing permission for customer documents ',
  },
  '-512': {
    zh: '没有项目文档在线编辑权限',
    cht: '沒有項目文檔在線編輯權限',
    en: ' no project document online editing permission ',
  },
  '-513': {
    zh: '文件过大不支持在线编辑',
    cht: '文件過大不支持在線編輯',
    en: ' File too large to support online editing ',
  },
  '-514': {
    zh: '文件格式不支持在线编辑',
    cht: '文件格式不支持在線編輯',
    en: ' File format does not support online editing ',
  },
  '-515': {
    zh: '您选择的内容均不支持提取，请重新选择',
    cht: '您選擇的內容均不支持提取，請重新選擇',
    en: ' None of the contents you selected can be extracted, please reselect ',
  },
  '-516': {
    zh: '您的服务订单为空，请重新操作',
    cht: '您的服務訂單爲空，請重新操作',
    en: ' Your service order is empty, please retry ',
  },
  '-517': {
    zh: '他人锁定无法解锁',
    cht: '他人鎖定無法解鎖',
    en: ' others lock cannot unlock ',
  },
  '-518': {
    zh: '文件正在进行在线编辑，不支持该操作',
    cht: '文件正在進行在線編輯，不支持該操作',
    en: ' the file is being edited online, this operation is not supported ',
  },
  '-519': {
    zh: '荣大内部人员请使用集团预上线环境智慧云系统！',
    cht: '榮大內部人員請使用集團預上線環境智慧雲系統！',
    en:
      " Rongda internal staff please use the Group's pre-launch environmental wisdom cloud system!",
  },
  '-520': {
    zh: '文件被锁定，无法进行编辑模式设置',
    cht: '文件被鎖定，無法進行編輯模式設置',
    en: ' File locked, unable to set edit mode ',
  },
  '-521': {
    zh: '文件正在被进行编辑模式设置,请稍后重试',
    cht: '文件正在被進行編輯模式設置,請稍後重試',
    en: ' file being set in edit mode, please try again later ',
  },
  '-522': {
    zh: '此文件不是在线编辑模式',
    cht: '此文件不是在線編輯模式',
    en: ' this file is not in online editing mode ',
  },
  '-523': {
    zh: '无法解除在线编辑锁',
    cht: '無法解除在線編輯鎖',
    en: ' cannot release online edit lock ',
  },
  '-524': {
    zh: '无法成功解除在线编辑保存锁',
    cht: '無法成功解除在線編輯保存鎖',
    en: ' unable to release online edit save lock successfully ',
  },
  '-525': {
    zh: '在线编辑地址为空',
    cht: '在線編輯地址爲空',
    en: ' online edit address is empty ',
  },
  '-526': {
    zh: '文件正在进行在线编辑，不支持该操作',
    cht: '文件正在進行在線編輯，不支持該操作',
    en: ' the file is being edited online, this operation is not supported ',
  },
  '-527': {
    zh: '递归次数过多获取失败',
    cht: '遞歸次數過多獲取失敗',
    en: ' too many recursion get failed ',
  },
  '-528': {
    zh: 'version is missing',
    cht: 'version is missing',
    en: 'versionismissing',
  },
  '-529': {
    zh: '多人在线编辑功能维护中,暂时无法使用',
    cht: '多人在線編輯功能維護中,暫時無法使用',
    en:
      ' multiplayer online editing function is under maintenance, temporarily unavailable ',
  },
  '-530': {
    zh: '获取WpsToken失败！',
    cht: '獲取WpsToken失敗！',
    en: ' Failed to get WpsToken!',
  },
  '-531': {
    zh: '源文件已经被删除或不存在，无法进行另存为操作',
    cht: '源文件已經被刪除或不存在，無法進行另存爲操作',
    en:
      ' source file has been deleted or does not exist, cannot be saved as operation ',
  },
  '-532': {
    zh: '聊天文件另存为异常',
    cht: '聊天文件另存爲異常',
    en: ' Save chat file as exception ',
  },
  '-533': {
    zh: '未查询到未读消息',
    cht: '未查詢到未讀消息',
    en: ' unread message not found ',
  },
  '-534': {
    zh: '获取项目创建人失败',
    cht: '獲取項目創建人失敗',
    en: ' failed to obtain project creator ',
  },
  '-535': {
    zh: '日志不存在',
    cht: '日誌不存在',
    en: ' log does not exist ',
  },
  '-536': {
    zh: '项目日志内容临时保存失败',
    cht: '項目日誌內容臨時保存失敗',
    en: ' Project log content temporarily saved failed ',
  },
  '-537': {
    zh: '系统级别会话无法发送消息',
    cht: '系統級別會話無法發送消息',
    en: ' system-level session cannot send messages ',
  },
  '-538': {
    zh: '相同ip不能重复添加规则',
    cht: '相同ip不能重複添加規則',
    en: ' Rules cannot be added to the same ip address repeatedly ',
  },
  '-539': {
    zh: 'ip规则无数据',
    cht: 'ip規則無數據',
    en: 'ip rules have no data ',
  },
  '-540': {
    zh: 'ip规则已删除，不可操作',
    cht: 'ip規則已刪除，不可操作',
    en: ' the ip rule has been deleted and cannot be operated ',
  },
  '-541': {
    zh: '文件解锁失败',
    cht: '文件解鎖失敗',
    en: ' file unlocking failed ',
  },
  '-542': {
    zh: '文件正在进行多人编辑，当前不支持本地编辑',
    cht: '文件正在進行多人編輯，當前不支持本地編輯',
    en:
      ' file is being edited by multiple people, local editing is not currently supported ',
  },
  '-543': {
    zh: '调用XBRL登录接口异常',
    cht: '調用XBRL登錄接口異常',
    en: ' error calling XBRL login interface ',
  },
  '-544': {
    zh: '调用XBRL校验服务是否初始化失败',
    cht: '調用XBRL校驗服務是否初始化失敗',
    en: ' Call XBRL to verify service initialization failed ',
  },
  '-545': {
    zh: '调用XBRL获取业务类型异常',
    cht: '調用XBRL獲取業務類型異常',
    en: ' Call XBRL to get business type exception ',
  },
  '-546': {
    zh: '勾选内容已被引用，不可删除',
    cht: '勾選內容已被引用，不可刪除',
    en: ' Check content has been referenced and cannot be deleted ',
  },
  '-547': {
    zh: 'XBRL获取分布式锁失败',
    cht: 'XBRL獲取分佈式鎖失敗',
    en: 'XBRL failed to acquire distributed lock ',
  },
  '-548': {
    zh: '分类标签获取分布式锁失败',
    cht: '分類標籤獲取分佈式鎖失敗',
    en: ' Class tag failed to obtain distributed lock ',
  },
  '-549': {
    zh: '获取锁失败',
    cht: '獲取鎖失敗',
    en: ' failed to acquire lock ',
  },
  '-550': {
    zh: '链接失效，请联系邀请人重新邀请',
    cht: '鏈接失效，請聯繫邀請人重新邀請',
    en: ' Link is invalid, please contact inviter to re-invite ',
  },
  '-551': {
    zh: '请输入正确验证码',
    cht: '請輸入正確驗證碼',
    en: ' Please enter the correct verification code ',
  },
  '-552': {
    zh: '计算fileSum时获取不到锁',
    cht: '計算fileSum時獲取不到鎖',
    en: ' no lock obtained while calculating fileSum ',
  },
  '-553': {
    zh: '计算fileSum时找不到文件',
    cht: '計算fileSum時找不到文件',
    en: ' No file found while calculating fileSum ',
  },
  '-554': {
    zh: '保存文件失败',
    cht: '保存文件失敗',
    en: ' failed to save file ',
  },
  '-555': {
    zh: '当前环境不支持更新app配置',
    cht: '當前環境不支持更新app配置',
    en:
      ' app configuration update is not supported in the current environment ',
  },
  '-556': {
    zh: '找不到文件',
    cht: '找不到文件',
    en: ' File not found ',
  },
  '-557': {
    zh: '不在该群内不能编辑群内文件',
    cht: '不在該羣內不能編輯羣內文件',
    en: ' cannot edit files in the group if not in the group ',
  },
  '-558': {
    zh: '该消息类型不是文件消息,不支持编辑',
    cht: '該消息類型不是文件消息,不支持編輯',
    en:
      ' this message type is not a file message and does not support editing ',
  },
  '-559': {
    zh: '标签全部为空格',
    cht: '標籤全部爲空格',
    en: ' label all Spaces ',
  },
  '-560': {
    zh: '另存为参数为空',
    cht: '另存爲參數爲空',
    en: ' Save as parameter null ',
  },
  '-561': {
    zh: '考试记录不存在',
    cht: '考試記錄不存在',
    en: ' Examination record does not exist ',
  },
  '-562': {
    zh: '考试已被中止',
    cht: '考試已被中止',
    en: ' the examination has been suspended ',
  },
  '-563': {
    zh: '考试已结束',
    cht: '考試已結束',
    en: ' the examination is over ',
  },
  '-564': {
    zh: '有必答题未作答',
    cht: '有必答題未作答',
    en: ' There are required questions not answered ',
  },
  '-565': {
    zh: '考试时间已到',
    cht: '考試時間已到',
    en: " it's time for the exam ",
  },
  '-566': {
    zh: '引用的考试已被删除',
    cht: '引用的考試已被刪除',
    en: ' referenced test has been deleted ',
  },
  '-567': {
    zh: '考试已不存在',
    cht: '考試已不存在',
    en: ' examinations no longer exist ',
  },
  '-568': {
    zh: '考试对应试卷为空',
    cht: '考試對應試卷爲空',
    en: ' the corresponding paper is empty ',
  },
  '-569': {
    zh: '统计考试对应试卷为空',
    cht: '統計考試對應試卷爲空',
    en: ' statistical exam corresponding paper is empty ',
  },
  '-570': {
    zh: '存在进行中的考试',
    cht: '存在進行中的考試',
    en: ' there is an examination in progress ',
  },
  '-571': {
    zh: '操作失败，文件路径不存在',
    cht: '操作失敗，文件路徑不存在',
    en: ' Operation failed, file path does not exist ',
  },
  '-572': {
    zh: '删除失败，当前文件/文件夹所在的上级目录正在进行剪切操作',
    cht: '刪除失敗，當前文件/文件夾所在的上級目錄正在進行剪切操作',
    en:
      ' Deletion failed, the current file/folder is in the process of cutting ',
  },
  '-573': {
    zh: '删除失败，当前文件/文件夹所在的上级目录正在进行复制操作',
    cht: '刪除失敗，當前文件/文件夾所在的上級目錄正在進行復制操作',
    en:
      ' Deletion failed, replication is in progress in the upper directory of the current file/folder ',
  },
  '-574': {
    zh: '删除失败，当前文件夹子目录内有文件/文件夹正在进行剪切操作',
    cht: '刪除失敗，當前文件夾子目錄內有文件/文件夾正在進行剪切操作',
    en:
      ' Delete failed, there are files/folders being clipped in the current folder directory ',
  },
  '-575': {
    zh: '删除失败，当前文件夹子目录内有文件/文件夹正在进行复制操作',
    cht: '刪除失敗，當前文件夾子目錄內有文件/文件夾正在進行復制操作',
    en:
      ' Deletion failed, there are files/folders being copied in the current folder directory ',
  },
  '-576': {
    zh: '操作失败，当前选择文件夹的上级目录正在被删除',
    cht: '操作失敗，當前選擇文件夾的上級目錄正在被刪除',
    en:
      ' Operation failed, parent directory of currently selected folder is being deleted ',
  },
  '-577': {
    zh: '操作失败，当前剪切文件/文件夹所在的上级目录正在进行复制操作',
    cht: '操作失敗，當前剪切文件/文件夾所在的上級目錄正在進行復制操作',
    en:
      ' Operation failed, copy is being performed in the upper directory of the current clipped file/folder ',
  },
  '-578': {
    zh: '操作失败，当前剪切文件夹内存在未被粘贴完成的内容',
    cht: '操作失敗，當前剪切文件夾內存在未被粘貼完成的內容',
    en:
      ' Operation failed, unpasted content exists in current clipping folder ',
  },
  '-579': {
    zh: '操作失败，当前操作文件夹的上级目录正在进行剪切操作',
    cht: '操作失敗，當前操作文件夾的上級目錄正在進行剪切操作',
    en:
      ' Operation failed, the parent directory of the current operation folder is cutting ',
  },
  '-580': {
    zh: '操作失败，当前操作文件夹内存在未被剪切完成的内容',
    cht: '操作失敗，當前操作文件夾內存在未被剪切完成的內容',
    en:
      ' Operation failed, unclipped content exists in current operation folder ',
  },
  '-581': {
    zh: '操作失败，当前选择目录正在进行剪切操作',
    cht: '操作失敗，當前選擇目錄正在進行剪切操作',
    en: ' Operation failed, currently selected directory is being clipped ',
  },
  '-582': {
    zh: '操作失败，当前文件/文件夹所在的上级目录正在进行剪切操作',
    cht: '操作失敗，當前文件/文件夾所在的上級目錄正在進行剪切操作',
    en:
      ' Operation failed, the current file/folder is being clipped in the upper directory ',
  },
  '-583': {
    zh: '操作失败，当前文件/文件夹所在的上级目录正在被删除',
    cht: '操作失敗，當前文件/文件夾所在的上級目錄正在被刪除',
    en:
      ' Operation failed, parent directory of current file/folder is being deleted ',
  },
  '-584': {
    zh: '操作失败，当前文件/文件夹所在的上级目录正在被删除',
    cht: '操作失敗，當前文件/文件夾所在的上級目錄正在被刪除',
    en:
      ' Operation failed, the parent directory of the current file/folder is being deleted ',
  },
  '-585': {
    zh: '操作失败，当前文件/文件夹所在的上级目录正在进行剪切操作',
    cht: '操作失敗，當前文件/文件夾所在的上級目錄正在進行剪切操作',
    en:
      ' Operation failed, the current file/folder is being clipped in the upper directory ',
  },
  '-586': {
    zh: '删除失败，当前文件夹子目录内有文件/文件夹正在进行锁定操作',
    cht: '刪除失敗，當前文件夾子目錄內有文件/文件夾正在進行鎖定操作',
    en:
      ' Deletion failed, files/folders in the current folder directory are being locked ',
  },
  '-587': {
    zh: '剪切失败，当前文件夹子目录内有文件/文件夹正在进行锁定操作',
    cht: '剪切失敗，當前文件夾子目錄內有文件/文件夾正在進行鎖定操作',
    en:
      ' Clipping failed, files/folders in the current folder directory are being locked ',
  },
  '-588': {
    zh: '操作失败，当前文件/文件夹所在的上级目录不存在',
    cht: '操作失敗，當前文件/文件夾所在的上級目錄不存在',
    en:
      ' Operation failed, the parent directory of the current file/folder does not exist ',
  },
  '-589': {
    zh: '操作失败,父目录不存在',
    cht: '操作失敗,父目錄不存在',
    en: ' Operation failed, parent directory does not exist ',
  },
  '-590': {
    zh: '操作失败,上传的文件/文件夹的项目与父级不一致,请刷新后重试',
    cht: '操作失敗,上傳的文件/文件夾的項目與父級不一致,請刷新後重試',
    en:
      ' Operation failed, the uploaded file/folder project is inconsistent with the parent, please refresh and try again ',
  },
  '-591': {
    zh: '操作失败，当前文件夹子目录内有文件/文件夹正在进行审批操作',
    cht: '操作失敗，當前文件夾子目錄內有文件/文件夾正在進行審批操作',
    en:
      ' Operation failed, there are files/folders in the current folder directory in the approval operation ',
  },
  '-592': {
    zh: '操作失败，当前上传文件/文件夹所在的上级目录正在进行审批操作',
    cht: '操作失敗，當前上傳文件/文件夾所在的上級目錄正在進行審批操作',
    en:
      ' Operation failed, approval is being performed in the upper directory of the uploaded file/folder ',
  },
  '-593': {
    zh: '操作失败，当前选择文件夹的正在被删除',
    cht: '操作失敗，當前選擇文件夾的正在被刪除',
    en: ' Operation failed, currently selected folder is being deleted ',
  },
  '-594': {
    zh: '操作失败，当前选择文件夹或下级的正在进行剪切',
    cht: '操作失敗，當前選擇文件夾或下級的正在進行剪切',
    en: ' Operation failed, currently selected folder or child is cutting ',
  },
  '-595': {
    zh: '该功能暂时关闭',
    cht: '該功能暫時關閉',
    en: 'This feature is temporarily off ',
  },
  '-596': {
    zh: '组织不存在,无法进行操作',
    cht: '組織不存在,無法進行操作',
    en: 'The organization does not exist and cannot operate ',
  },
  '-597': {
    zh: '请求网关失败',
    cht: '請求網關失敗',
    en: 'Gateway request failed ',
  },
  '-598': {
    zh: '该消息不在此会话中',
    en: 'This message is not in this conversation',
    cht: '該消息不在此會話中',
  },
  '-599': {
    zh: '文件已超出限制（10M），暂不支持处理',
    en:
      'The file has exceeded the limit (10M) and currently does not support processing',
    cht: '文件已超出限製（10M），暫不支持處理',
  },
  '-600': {
    zh: '任务进行中',
    en: 'Task in progress',
    cht: '任務進行中',
  },
  '-601': {
    zh: '顶级对象查找错误',
    en: 'top-level object lookup error',
    cht: '頂級對象查找錯誤',
  },
  '-602': {
    zh: '必传数据内容为空',
    en: 'Required data content is empty',
    cht: '必傳數據內容為空',
  },
  '-603': {
    zh: '暂不支持复制项目文档内容到个人网盘，请重新选择',
    en:
      'Currently does not support copying project document content to personal online drives, please reselect',
    cht: '暫不支持復製項目文檔內容到個人網盤，請重新選擇',
  },
  '-604': {
    zh: '【批量建立文件夹】执行失败',
    en: 'Batch folder creation failed',
    cht: '【批量建立文件夾】執行失敗',
  },
  '-605': {
    zh: '导出文件目录执行失败',
    en: 'Export file directory execution failed',
    cht: '導出文件目錄執行失敗',
  },
  '-606': {
    zh: '文件工具箱任务结果文件生成失败',
    en: 'File toolbox task result file generation failed',
    cht: '文件工具箱任務結果文件生成失敗',
  },
  '-607': {
    zh: '导出失败，仅支持导出50层文件夹，请选择子目录分开导出',
    en:
      'Export failed, only supports exporting 50 level folders, please select sub directories to export separately',
    cht: '導出失敗，僅支持導出50層文件夾，請選擇子目錄分開導出',
  },
  '-608': {
    zh: '待提取名称列超出行数限制，暂不支持处理',
    en:
      'The name column to be extracted exceeds the travel limit and currently does not support processing',
    cht: '待提取名稱列超出行數限製，暫不支持處理',
  },
  '9052': {
    zh: '您的实名认证即将到期，请尽快进行认证！',
    cht: '您的實名認證即將到期，請盡快進行認證！',
    en:
      'Your real-name authentication is about to expire. Please complete the authentication as soon as possible!',
  },
};
